import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import noImage from "../images/clicktoAdd.png";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  DEFAULT_WAREHOUSE,
  DEMO_VALUE,
  NEW_ENTRY,
  MAIN_IMAGE_PART,
  WEB_IMAGE_PART,
  FRONT_IMAGE_PART,
  BACK_IMAGE_PART,
  DOCUMENT_CHANGED,
} from "../ds/App_Constants";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AddressBean,
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleImageBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  LogisticOrderBean,
  LogisticOrderLineAdjustmentBean,
  LogisticOrderLineBean,
  LogisticOrderSearchCriteria,
  PageListBean,
  ReasonBean,
  RestCustomerListRequest,
  RestEntityPrintRequest,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestLogisticOrderListRequest,
  RestLogisticOrderRequest,
  RestReadRequest,
  LogisticOrderDocumentBean,
  LogisticOrderImageBean,
} from "../ds/ds.js";
import { KeyConstants } from "../ds/Key_Constants.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  CameraIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
  ExcelIcon,
  UploadDocIcon,
} from "../gui_components/Icons.js";
import {
  AddressComponent,
  AlertToolBox,
  DatePickerComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
  TimePickerComponent,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1
} from "../gui_components/Util.js";
import {
  PopupFabricInventoryPositionInq,
  PopupFabricPurchaseHistoryInq,
  PopupItemCurrentInventoryInq,
} from "../Inquiry/InquiryUtil.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { LogisticOrderLookupHandler } from "../lookup/LogisticOrderLookupHandler.js";
import { PopupFabricModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { LogisticOrderService } from "../services/LogisticOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
class LogisticOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "InBound Order",
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticOrderHistoryFormOpen: false,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: false,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      error_list: [],
      selectedNodeKey: "headerView",
      nodeList: [],
      isResetModule: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowAlertLvl5: false,
      moduleKeyCode: NEW_ENTRY,
      isResetView: true,
      isMaintenanceMode: true,
      isShowModuleSearchContainer: false,
      order: "",
      sortField: "",
      logisticOrderData: new LogisticOrderBean(),
      criteria: new LogisticOrderSearchCriteria(),
      pageList: new PageListBean(),
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      isSpecialViewModeError: false,
      logisticOrderLookupHandler: null,
      logisticOrder_list: new Array(),
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      unapprovalReasons: new Array(),
      wareHouses: new Array(),
      cancelReasons: new Array(),
      cityList: new Array(),
      stateList: new Array(),
      countryList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      reasonData: new ReasonBean(),
      unApproveReasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),

      addressData: new AddressBean(),
      isShowAddressPopup: false,
      showAutoCompleteCityList: false,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: false,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: false,
      countryPageListForAutoCompleteList: new Array(),

      logisticOrderLineData: new LogisticOrderLineBean(),
      isShowLinePopup: false,
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteColourList: false,
      fabricColourPageListForAutoCompleteList: new Array(),
      isShowAlertLvl0: false,
      moduleOrderStatus: "",
      is3PL: false,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isShowAdjustedQuantityPopup: false,
      isShowAlertLvl1: false,
      adjLines: new Array(),
      adjustmentData: new LogisticOrderLineAdjustmentBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      adjReasons: new Array(),
      isAllowManualAdjustment: false,
      isShowUomLookup: false,
      uomLookupHandler: null,
      uoms: new Array(),
      uomPageListForAutoCompleteList: new Array(),
      showAutoCompleteUOMList: false,
      isReseted: false,
      isViewMode: false,
      isDisabledFields: false,

      isShowFabricModule: false,
      isShowItemInventoryPositionInq: false,
      isShowItemCurrentInventoryInq: false,
      isShowFabricPurchaseHistoryInq: false,
      colorLookupHandler: null,
      fabricStyleData: new FabricStyleBean(),

      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,
      disableUpdatableFields: false,



      images: [],
      preview_Url: [],
      isImageFormOpened: false,
      tempIndex: null,


      documents: [],
      preview_Docs: [],
      isImageFormOpened: false,
      tempIndex: null,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "InBound Order Maintenance";
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.wareHouses.push(attr);
      });
    }
    this.state.unapprovalReasons = [];
    let unapprovalReasons = attribute_cache.purchaseOrderUnApprovalReasons;
    if (!isEmptyArray(unapprovalReasons))
      unapprovalReasons.map((ent) => {
        this.state.unapprovalReasons.push(ent);
      });
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.purchaseOrderCancelReasons;
    if (!isEmptyArray(cancelReasons))
      cancelReasons.map((ent) => {
        this.state.cancelReasons.push(ent);
      });
    this.state.cityList = [];
    let cityList = attribute_cache.cities;
    if (!isEmptyArray(cityList))
      cityList.map((ent) => {
        this.state.cityList.push(ent);
      });
    this.state.stateList = [];
    let stateList = attribute_cache.states;
    if (!isEmptyArray(stateList))
      stateList.map((ent) => {
        this.state.stateList.push(ent);
      });
    this.state.countryList = [];
    let countryList = attribute_cache.countries;
    if (!isEmptyArray(countryList))
      countryList.map((ent) => {
        this.state.countryList.push(ent);
      });
    this.state.adjReasons = [];
    let adjReasons = attribute_cache.inventoryAdjustmentReasons;
    if (adjReasons != null || adjReasons != undefined) {
      adjReasons.map((attr) => {
        this.state.adjReasons.push(attr);
      });
    }
  };
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    const { cache } = appData;
    this.cache = cache;
    this.fetchAttributesFromLocalStorage();
    ModuleUtils.getLogisticOrderStatusList();
    ModuleUtils.getLogisticOrderLineStatusList();
    let isSpecialViewMode = this.state.isSpecialViewMode;
    

    let isReadOnly = this.state.isReadOnlyOrDisabled;


    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      this.state.isSpecialViewMode = isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;  
    }
    this.setState({
      isSpecialViewMode: isSpecialViewMode,
      isReadOnlyOrDisabled: isReadOnly,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editLogisticOrder(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    this.initLookupHandlers();
    // this.loadPage(1);
  }
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  initLookupHandlers = () => {
    //
    let logisticOrderLookupHandler = new LogisticOrderLookupHandler(
      this.companyCode,
      "Order"
    );
    this.setState({ logisticOrderLookupHandler: logisticOrderLookupHandler });
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  getListResponse = (response) => {
    let logisticOrder_list = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrderPageList) &&
      !isEmptyArray(response.data.logisticOrderPageList.logisticOrders)
    ) {
      logisticOrder_list = response.data.logisticOrderPageList.logisticOrders;
      this.state.pageList.totalCount =
        response.data.logisticOrderPageList.totalCount;
      this.state.pageList.currentPage =
        response.data.logisticOrderPageList.currentPage;
    }
    this.setState({
      logisticOrder_list: logisticOrder_list,
      isLoading: false,
      loadingText: "",
    });
  };
  loadLogisticOrderPage = () => {
    let request = new RestLogisticOrderListRequest();
    request.pageInput = this.state.pageList;
    const criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    request.criteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.LogesticOrder_IsAccessible()) {
      LogisticOrderService.getLogisticOrderPageList(
        request,
        this.getListResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };
  addNewEntry = () => {
    let logisticOrderData = new LogisticOrderBean();
    logisticOrderData.companyCode = this.companyCode;
    logisticOrderData.code = NEW_ENTRY;
    logisticOrderData.locationCode = DEFAULT_WAREHOUSE;
    logisticOrderData.orderStatus =
      LogicConstants.LOGISTIC_ORDER_UNAPPROVE_STATUS;
    //logisticOrderData.orderDate = new Date().toLocaleDateString("sv-SE");
    logisticOrderData.orderDate = toFormattedDate_v1(new Date());
    let pageTitle = this.moduleCaption + " - NEW";

    if (!isEmptyString(this.state.moduleKeyCode)) {
      logisticOrderData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    }

    this.setState({
      logisticOrderData: logisticOrderData,
      pageTitle: pageTitle,
      isLoading: false,
      loadingText: "",
      selectedNodeKey: "headerView",
    });
    this.state.logisticOrderData = logisticOrderData;
    this.openEntryForm();
  };
  openEntryForm = () => {
    //
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isLogisticOrderEntryFormOpen: true,
      isLogisticOrderListFormOpen: false,
      isShowSaveButton: true,
      isShowClearErrorButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isLogisticOrderHistoryFormOpen: false,
      isDisabledFields: false,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isLogisticOrderListFormOpen: false,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          // isDisableNodeFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        disabled: true,
        isDisabledFields: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }

    let moduleOrderStatus = this.state.moduleOrderStatus;
    let orderStatus = ModuleUtils.getLogisticOrderStatusCaption(
      this.state.logisticOrderData.orderStatus
    );
    if (orderStatus !== undefined && orderStatus !== null) {
      moduleOrderStatus = orderStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    this.initModuleButtons();
  };
  initModuleButtons = () => {
    let logisticOrderData = this.state.logisticOrderData;
    if (
      logisticOrderData.orderStatus ==
      LogicConstants.LOGISTIC_ORDER_UNAPPROVE_STATUS
    ) {
      if (logisticOrderData.isFetched) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: true,
          isShowSaveButton: true,
          isShowPDFReportButton: true,
          isShowExcelButton: true,
          // isDisabledFields: false,
          disableUpdatableFields: false,
        });
      } else {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowSaveButton: true,
          isShowPDFReportButton: false,
          isShowExcelButton: false,
          isDisabledFields: false,
          disableUpdatableFields: false,
        });
      }
    }
    if (
      logisticOrderData.orderStatus ==
      LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: true,
        isShowCancelButton: true,
        isShowApproveButton: false,
        isShowSaveButton: true,
        isShowPDFReportButton: true,
        isShowExcelButton: true,
        isDisabledFields: true,
        disableUpdatableFields: false,
      });
    }
    if (
      logisticOrderData.orderStatus ==
      LogicConstants.LOGISTIC_ORDER_CANCEL_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: false,
        isShowCancelButton: false,
        isShowApproveButton: false,
        isShowSaveButton: false,
        isShowPDFReportButton: false,
        isShowExcelButton: false,
        isDisabledFields: true,
        disableUpdatableFields: true,
      });
    }
    if (
      logisticOrderData.orderStatus ==
      LogicConstants.LOGISTIC_ORDER_RECEIVED_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: false,
        isShowCancelButton: false,
        isShowApproveButton: false,
        isShowSaveButton: true,
        isShowPDFReportButton: true,
        isShowExcelButton: true,
        isDisabledFields: true,
        disableUpdatableFields: false,
      });
    }
    if (
      logisticOrderData.orderStatus ==
      LogicConstants.LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS
    ) {
      this.setState({
        isShowUnApproveButton: false,
        isShowCancelButton: true,
        isShowApproveButton: false,
        isShowSaveButton: true,
        isShowPDFReportButton: true,
        isShowExcelButton: true,
        isDisabledFields: true,
        disableUpdatableFields: false,
      });
    }
  };
  closeEntryForm = () => {
    this.clearError();
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: true,
      isShowSaveButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isLogisticOrderHistoryFormOpen: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isSpecialViewModeError: false,
      isDisabledFields: false,
      // isDisableNodeFields: false,
      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: false,
    });
  };

  show_Toast = (msg, type, lvl) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        // isShowAlertLvl1: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        // isShowAlertLvl1: true,
      });
    }
    if (lvl == 1) {
      this.setState({
        isShowAlertLvl1: true,
      });
    } else if (lvl == 5) {
      this.setState({
        isShowAlertLvl5: true,
      });
    }
  };

  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let historyNode = new NodeData("historyView", "History", headerObject);
    let imageNode = new NodeData("imageView", "Image", headerObject);
    let documentNode = new NodeData("documentView", "Document", headerObject);
    let logisticOrderData = this.state.logisticOrderData;
    nodeList["headerView"] = headerNode;
    if (logisticOrderData.isFetched) {
      nodeList["historyView"] = historyNode;
      nodeList["imageView"] = imageNode;
      nodeList["documentView"] = documentNode;
    }
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    if (selectedNode == "headerView") {
      this.setLogisticOrderHeaderView();
    } else if (selectedNode == "historyView") {
      this.setLogisticOrderHistoryView();
    } else if (selectedNode == "imageView") {
      this.setLogisticOrderImageView();
    } else if (selectedNode == "documentView") {
      this.setLogisticOrderDocumentView();
    }
    this.setState({ selectedNodeKey: selectedNode });
  };
  setLogisticOrderImageView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticOrderHistoryFormOpen: false,
      isLogisticOrderImageFormOpen: true,
      isLogisticOrderDocumentFormOpen: false,
    });
  }
  setLogisticOrderDocumentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticOrderHistoryFormOpen: false,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: true,
    });
  }
  setLogisticOrderHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isLogisticOrderEntryFormOpen: true,
      isLogisticOrderListFormOpen: false,
      isLogisticOrderHistoryFormOpen: false,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: false,
    });
  };
  setLogisticOrderHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticOrderHistoryFormOpen: true,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: false,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isLogisticOrderEntryFormOpen: false,
      isLogisticOrderListFormOpen: false,
      isLogisticOrderHistoryFormOpen: false,
      isLogisticOrderImageFormOpen: false,
      isLogisticOrderDocumentFormOpen: false,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readOrderResponse = (response) => {

    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        if (!this.state.isSpecialViewMode)
          this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.logisticOrderResponse != null) {
      if (response.data.logisticOrderResponse.errors != null) {
        response.data.logisticOrderResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (this.state.isSpecialViewMode) {
      this.setState({
        isSpecialViewModeError: true,
      });
      if (errMsg.includes("Not read"))
        this.showErrorMessage(response.data.logisticOrderResponse);
    } else if (!errMsg.includes("Not read"))
      this.showErrorMessage(response.data.logisticOrderResponse);
    // if (
    //   errMsg !=
    //   "readLogisticOrder [" + this.state.moduleKeyCode + "] Not read!"
    // ) {
    //   this.showErrorMessage(response.data.logisticOrderResponse);
    // }
    if (response.data.isSuccess == true) {
      this.setState({ isLoading: false, loadingText: "" });
      if (
        response.data.logisticOrderResponse != null &&
        response.data.logisticOrderResponse.logisticOrder != null
      ) {
        const logisticOrderData =
          response.data.logisticOrderResponse.logisticOrder;
        let pageTitle = this.moduleCaption + " - VIEW";
        let moduleKeyCode = logisticOrderData.code;
        // this.clearError();

        // if (
        //   !isEmptyArray(
        //     response.data.logisticOrderResponse.logisticOrder.orderImages
        //   )
        // ) {
        //   const itemImage__List =
        //     response.data.logisticOrderResponse.logisticOrder.orderImages;
        //   itemImage__List.map((img) => {
        //     if (img.imagePart === MAIN_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setMainUrl(url);
        //     }
        //     if (img.imagePart === WEB_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setWebUrl(url);
        //     }
        //     if (img.imagePart === FRONT_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setFrontUrl(url);
        //     }
        //     if (img.imagePart === BACK_IMAGE_PART) {
        //       let url = this.getImageURL();
        //       url = url + img.imageName;
        //       this.setBackUrl(url);
        //     }
        //   });
        //   this.setState({
        //     mainImgData: null,
        //     webImgData: null,
        //     frontImgData: null,
        //     BackImgData: null,
        //   });
        // } else {
        //   this.setState({
        //     mainImageUrl: "",
        //     webImageUrl: "",
        //     frontImageUrl: "",
        //     backImageUrl: "",
        //     mainImgData: null,
        //     webImgData: null,
        //     frontImgData: null,
        //     BackImgData: null,
        //   });
        // }

        // if (
        //   !isEmptyArray(
        //     response.data.logisticOrderResponse.logisticOrder
        //       .logisticOrderDocuments
        //   )
        // ) {
        //   const itemDocuments__List =
        //     response.data.logisticOrderResponse.logisticOrder
        //       .logisticOrderDocuments;
        //   this.setState({
        //     doc1Url: "",
        //     doc2Url: "",
        //     doc3Url: "",
        //     doc4Url: "",
        //     doc1Data: null,
        //     doc2Data: null,
        //     doc3Data: null,
        //     doc4Data: null,
        //     doc1Name: "",
        //     doc2Name: "",
        //     doc3Name: "",
        //     doc4Name: "",
        //   });
        //   itemDocuments__List.map((doc) => {
        //     if (doc.documentNumber == 1) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc1Url(url);
        //       this.setDoc1Name(doc.documentName);
        //       // this.setDoc1Data(doc);
        //     } else if (doc.documentNumber == 2) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc2Url(url);
        //       this.setDoc2Name(doc.documentName);
        //       // this.setDoc2Data(doc);
        //     } else if (doc.documentNumber == 3) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc3Url(url);
        //       this.setDoc3Name(doc.documentName);
        //       // this.setDoc3Data(doc);
        //     } else if (doc.documentNumber == 4) {
        //       let url = this.getDocURL();
        //       url = url + doc.documentName;
        //       this.setDoc4Url(url);
        //       this.setDoc4Name(doc.documentName);
        //       // this.setDoc4Data(doc);
        //     }
        //   });
        //   this.setState({
        //     doc1Data: null,
        //     doc2Data: null,
        //     doc3Data: null,
        //     doc4Data: null,
        //   });
        // } else {
        //   this.setState({
        //     doc1Url: "",
        //     doc2Url: "",
        //     doc3Url: "",
        //     doc4Url: "",
        //     doc1Data: null,
        //     doc2Data: null,
        //     doc3Data: null,
        //     doc4Data: null,
        //     doc1Name: "",
        //     doc2Name: "",
        //     doc3Name: "",
        //     doc4Name: "",
        //   });
        // }


        if (!isEmptyArray(logisticOrderData.logisticOrderDocuments)) {
          const preview_Docs = logisticOrderData.logisticOrderDocuments;
          let url = this.getDocURL();
          let urlDoc_list = [];
          preview_Docs.map((urlIndex) => {
            urlDoc_list.push(url + urlIndex.documentName);
          });
          this.setState({
            documents: preview_Docs,
            preview_Docs: urlDoc_list,
          });
        } else {
          this.setState({
            preview_Docs: [],
            documents: [],
          });
        }
        if (!isEmptyArray(logisticOrderData.orderImages)) {
          const imagesList = logisticOrderData.orderImages;

          let url = this.getImageURL();
          let url_list = [];
          imagesList.map((urlIndex) => {
            url_list.push(url + urlIndex.imageName);
          });
          this.setState({
            imgData: null,
            preview_Url: url_list,
            images: imagesList,
          });
        } else {
          this.setState({
            imgUrl: "",
            imgData: null,
            images: [],
            preview_Url: [],
          });
        }
        this.state.logisticOrderData = logisticOrderData;

        this.setState({
          logisticOrderData: logisticOrderData,
          pageTitle: pageTitle,
          isShowNodes: true,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
          loadingText: "",
          selectedNodeKey: "headerView",
        });
        this.isLocked = true;
        this.getNodeList();
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  editLogisticOrder = (code) => {
    const readrequest = new RestReadRequest();
    readrequest.code = code;
    readrequest.companyCode = this.companyCode;
    readrequest.isLoadChildren = true;
    if (!this.state.isSpecialViewMode) {
      let isLockRequired = NEW_ENTRY === code ? false : true;
      readrequest.isLockRequired = isLockRequired;
    } else {
      readrequest.isLockRequired = false;
    }
    if (SecurityAccessManager.LogisticOrderView_IsAccessible()) {
      LogisticOrderService.initLogisticOrderModule(
        readrequest,
        this.readOrderResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isLoading: true,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  unlockResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editLogisticOrder(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unLockLogisticOrder = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.LogesticOrder_IsAccessible()) {
      LogisticOrderService.unLockLogisticOrderNumber(
        request,
        this.unlockResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  moduleExit = () => {
    let logisticOrderData = this.state.logisticOrderData;
    if (logisticOrderData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unLockLogisticOrder(logisticOrderData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  clearError = () => {
    this.state.error_list = new Array();
    this.state.alertMessage = new Array();
    this.setState({ error_list: [], isShowAlert: false });
  };
  resetView = () => {
    let logistic_OrderData = this.state.logisticOrderData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unLockLogisticOrder(logistic_OrderData.code);
    } else {
      this.isLocked = false;
    }
    let logisticOrderData = new LogisticOrderBean();

    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.setState({
      isShowAlert: false,
      isResetModule: true,
      disabled: false,
      selectedNodeKey: "headerView",
      logisticOrderData: logisticOrderData,

      isShowItemImagePopup: false,
      mainImageUrl: "",
      webImageUrl: "",
      frontImageUrl: "",
      backImageUrl: "",
      mainImgData: null,
      webImgData: null,
      frontImgData: null,
      BackImgData: null,

      isShowItemDocPopup: false,
      doc1Url: "",
      doc2Url: "",
      doc3Url: "",
      doc4Url: "",
      doc1Name: "",
      doc2Name: "",
      doc3Name: "",
      doc4Name: "",
      doc1Data: null,
      doc2Data: null,
      doc3Data: null,
      doc4Data: null,
    });
    this.hideAlertCallBack();

    this.clearError();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    if (!this.isLocked) {
      this.editLogisticOrder(this.state.moduleKeyCode);
    }

    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getModuleListView = () => {
    let logisticOrderData = this.state.logisticOrderData;
    if (logisticOrderData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPage(1);
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unLockLogisticOrder(logisticOrderData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPage(1);
    }
  };
  handleKeyDown = () => {
    this.editLogisticOrder(this.state.moduleKeyCode);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadLogisticOrderPage();
  };
  criteriaOnChange = (e) => {
    const criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;

    this.setState({ criteria: criteria });
  };
  filterLogisticOrder = () => {
    this.loadPage(1);
  };
  resetLogisticOrder = () => {
    let criteria = new LogisticOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });

    this.loadPage(1);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let logisticOrder_list = this.state.logisticOrder_list;
    if (sortField && !isEmptyArray(logisticOrder_list)) {
      const sorted = [...logisticOrder_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ logisticOrder_list: sorted });
    }
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };

  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    this.downloadReport(1, this.state.logisticOrderData.code);
  };
  generateExcel = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Generating Excel",
      });
      this.downloadReport(2, this.state.logisticOrderData.code);
    }
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new RestEntityPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.entityCode = code;
    requestInput.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.LogisticOrderPDFReport_IsAccessible()) {
        ReportService.generateLogisticOrderPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (SecurityAccessManager.LogisticOrderExcelReport_IsAccessible()) {
        ReportService.generateLogisticOrderPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  saveResponse = (response) => {
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrder)
    ) {
      const logisticOrderData = response.data.logisticOrder;
      if (response.data.success == true) {
        this.state.logisticOrderData = logisticOrderData;
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          isLoading: false,
          logisticOrderData: logisticOrderData,
          loadingText: "",
          pageTitle: pageTitle,
        });

        // this.uploadImagesToServer();
        // this.uploadDocsToServer();

        this.uploadMultiDocsToServer();
        this.uploadImagesToServer();

        if (!this.isLocked) {
          this.editLogisticOrder(response.data.logisticOrder.code);
        } else {
          this.code = logisticOrderData.code;
          this.unLockLogisticOrder(response.data.logisticOrder.code);
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  saveLogisticOrder = (logisticOrderData) => {
    this.setState({ isLoading: true, loadingText: "Saving .." });
    if (logisticOrderData.isFetched) {
      if (
        logisticOrderData.orderStatus ==
        LogicConstants.LOGISTIC_ORDER_UNAPPROVE_STATUS
      ) {
        if (SecurityAccessManager.LogisticOrderCreation_IsAccessible()) {
          LogisticOrderService.updateLogisticOrder(
            logisticOrderData,
            this.saveResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else if (logisticOrderData.orderStatus ==
        LogicConstants.LOGISTIC_ORDER_APPROVE_STATUS ||
        logisticOrderData.orderStatus ==
        LogicConstants.LOGISTIC_ORDER_RECEIVED_STATUS ||
        logisticOrderData.orderStatus ==
        LogicConstants.LOGISTIC_ORDER_PARTIALLY_RECEIVED_STATUS) {
        if (SecurityAccessManager.LogisticOrderUpdation_IsAccessible()) {
          LogisticOrderService.updateLogisticOrderAfterApproval(
            logisticOrderData,
            this.saveResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      if (SecurityAccessManager.LogisticOrderUpdation_IsAccessible()) {
        LogisticOrderService.createLogisticOrder(
          logisticOrderData,
          this.saveResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );
        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(errMsg)) {
      let errorMsg = [];
      errorMsg.push(errMsg);
      this.setState({
        alertMessage: errorMsg,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  approveResponse = (response) => {
    let isSuccess = this.handleApproveResponse(response.data);
    if (isSuccess) {
      if (
        !isEmpty(response.data) &&
        !isEmpty(response.data.mainOperationResponse) &&
        !isEmpty(response.data.mainOperationResponse.logisticOrder)
      ) {
        const logisticOrderData =
          response.data.mainOperationResponse.logisticOrder;
        this.state.logisticOrderData = logisticOrderData;
        this.uploadImagesToServer();
        this.uploadDocsToServer();
        this.editLogisticOrder(logisticOrderData.code);
      }
    }
    this.setState({ isLoading: false, loadingText: "" });
  };
  validateData = (data) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.customerCode)) {
        let errMsg = "Customer is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.customerName)) {
        let errMsg = "CustomerName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.locationCode)) {
        let errMsg = "WareHouse is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyArray(data.lines)) {
        let errMsg = "InBound Lines Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
      this.setState({ isShowAlert: false });
    }
    return isValidData;
  };
  approveLogisticOrder = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving InBound Order",
      });
      const logisticOrderData = this.state.logisticOrderData;
      let isValidData = false;
      isValidData = this.validateData(logisticOrderData);
      const input = new RestLogisticOrderRequest();
      input.order = logisticOrderData;
      logisticOrderData.isFetched
        ? (input.isLockRequired = true)
        : (input.isLockRequired = false);
      if (isValidData) {
        if (logisticOrderData.isFetched) {
          if (
            SecurityAccessManager.LogisticOrderUpdationAfterApproval_IsAccessible()
          ) {
            LogisticOrderService.updateAndApproveLogisticOrder(
              input,
              this.approveResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
            this.setState({ isLoading: false, loadingText: "" });
          }
        } else {
          if (
            SecurityAccessManager.LogisticOrderCreation_IsAccessible() &&
            SecurityAccessManager.LogisticOrderApproval_IsAccessible()
          ) {
            LogisticOrderService.createAndApproveLogisticOrder(
              input,
              this.approveResponse,
              this.errorCallBack
            );
          } else {
            let errMsg = "Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              alertType: "danger",
              isShowAlert: true,
            });
            this.setState({ isLoading: false, loadingText: "" });
          }
        }
      } else {
        this.setState({ isLoading: false, loadingText: "" });
      }
    }
  };
  onReasonChange = (e) => {
    this.state.showAutoCompleteReasonList = true;
    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
    if (isEmpty(e.target.value)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && e.target.value !== "") {
      this.readReasonBySearchString(e.target.value);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }
    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  onUnApproveReasonChange = (e) => {
    const code = e.target.value;
    this.state.showAutoCompleteUnApproveReasonList = true;

    const reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteUnApproveReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUnApproveReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteUnApproveReasonList: showAutoCompleteList,
        reasonData: reason,
        unApproveReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readUnApproveReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.unapprovalReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteUnApproveReasonList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteUnApproveReasonList;
          this.setState({
            showAutoCompleteUnApproveReasonList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readUnApproveReasonBySearchString(searchString) {
    let reasonData = this.state.unapprovalReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(searchString.toLowerCase()) > -1
    );
    this.setState({
      unApproveReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  unApproveReasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    reasonData["code"] = e.target.value;
    let reasonList = this.state.unapprovalReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        unApproveReasonPageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteUnApproveReasonList = (showAutoCompleteList) => {
    this.setState({
      showAutoCompleteUnApproveReasonList: showAutoCompleteList,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowUnApproveReasonPopup: false,
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
    });
  };
  unApproveResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrder)
    ) {
      const logisticOrderData = response.data.logisticOrder;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        logisticOrderData: logisticOrderData,
        pageTitle: pageTitle,
      });
      if (this.isLocked) {
        this.code = logisticOrderData.code;
        this.unLockLogisticOrder(logisticOrderData.code);
      }
    }
  };
  saveUnApprove = () => {
    this.setState({
      isLoading: true,
      loadingText: "UnApproving InBound Order",
    });
    const logisticOrderData = this.state.logisticOrderData;
    const request = new RestLogisticOrderRequest();
    request.order = logisticOrderData;
    request.reason = this.state.reasonData;
    if (SecurityAccessManager.LogisticOrderUnApproval_IsAccessible()) {
      LogisticOrderService.unApproveLogisticOrder(
        request,
        this.unApproveResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApprove();
    this.closeReasonModelCallBack();
  };
  unApproveLogisticOrder = (e) => {
    if (e.detail == 1) this.openReasonCapture(2);
  };
  cancelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.logisticOrder)
    ) {
      const logisticOrderData = response.data.logisticOrder;
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        logisticOrderData: logisticOrderData,
        pageTitle: pageTitle,
      });
      if (this.isLocked) {
        this.code = logisticOrderData.code;
        this.unLockLogisticOrder(logisticOrderData.code);
      }
    }
  };

  saveAndcancelLogisticOrder = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling InBound Order",
    });
    const logisticOrderData = this.state.logisticOrderData;
    const request = new RestLogisticOrderRequest();
    request.order = logisticOrderData;
    request.reason = this.state.reasonData;
    if (SecurityAccessManager.LogisticOrderCancel_IsAccessible()) {
      LogisticOrderService.cancelLogisticOrder(
        request,
        this.cancelResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        loadingText: "",
      });
    }
  };
  onCancelReasonContinue = () => {
    this.saveAndcancelLogisticOrder();
    this.closeReasonModelCallBack();
  };
  cancelLogisticOrder = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  save = () => {
    const logisticOrderData = this.state.logisticOrderData;
    this.saveLogisticOrder(logisticOrderData);
  };
  /**** header ******* */
  onChange = (e) => {
    let logisticOrderData = this.state.logisticOrderData;
    logisticOrderData[e.target.name] = e.target.value;
    this.setState({ logisticOrderData: logisticOrderData });
  };
  customerOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let logisticOrderData = this.state.logisticOrderData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let logisticOrderData = this.state.logisticOrderData;
      logisticOrderData.customerCode = "";
      logisticOrderData.customerName = "";
      logisticOrderData.address = new AddressBean();
      logisticOrderData.lines = new Array();
      let suggestion = [];
      this.setState({
        isShowAutoCompleteCustomerList: showAutoCompleteList,
        logisticOrderData: logisticOrderData,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerCodeBySearchString(e.target.value);
      }, 200);
    }
    logisticOrderData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ logisticOrderData: logisticOrderData });
  };
  readCustomerCodeBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.errorCallBack
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.customerPageList) &&
      !isEmptyArray(response.data.customerPageList.customers)
    ) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerEnterKeyEventHandler = (e) => {
    this.readCustomer(e.target.value);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.customer)) {
      let customerData = response.data.customer;
      let logisticOrderData = this.state.logisticOrderData;
      logisticOrderData.customerCode = customerData.code;
      logisticOrderData.customerName = customerData.description;
      logisticOrderData.lines = new Array();
      this.setState({
        logisticOrderData: logisticOrderData,
      });
      this.setCustomerDetails(customerData);
    }
  };
  readCustomer = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomerWithChildren(
      readrestInput,
      this.readCustomerResponse,
      this.errorCallBack
    );
  };
  setCustomerDetails(customer) {
    let logisticOrderData = this.state.logisticOrderData;
    if (customer != null && customer != undefined) {
      let customerAddress = customer.address;
      if (customerAddress != null && customerAddress != undefined) {
        let address = new AddressBean();
        address.address1 = customerAddress.address1;
        address.address2 = customerAddress.address2;
        address.address3 = customerAddress.address3;
        address.address4 = customerAddress.address4;
        address.city = customerAddress.city;
        address.state = customerAddress.state;
        address.country = customerAddress.country;
        address.zip = customerAddress.zip;
        if (!address.zip) address.zip = "36";
        address.email = customerAddress.email;
        address.mobilePhone = customerAddress.mobilePhone;
        address.phone1 = customerAddress.phone1;
        address.phone2 = customerAddress.phone2;
        address.fax = customerAddress.fax;
        address.website = customerAddress.website;
        address.contactPerson = customer.code;
        logisticOrderData.address = address;
      }

      let addressData = new AddressBean();
      this.setState({
        logisticOrderData: logisticOrderData,
        addressData: addressData,
      });
    }
  }
  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempData = this.state.logisticOrderData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempData = this.state.logisticOrderData;
      tempData.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteLocationList: showAutoCompleteList,
        logisticOrderData: tempData,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
      this.readLocation(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ logisticOrderData: tempData });
  };
  locationEnterKeyEventHandler = (e) => {
    this.readLocation(e.target.value);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCompleteLocationList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((obj) => {
        let locationBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLocation = (locationCode) => {
    let tempData = this.state.logisticOrderData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempData.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        logisticOrderData: tempData,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };

  addressClickHandler = (e) => {
    if (e.detail === 1) {
      let logisticOrderData = this.state.logisticOrderData;
      let addressData = new AddressBean();
      addressData = { ...logisticOrderData.address };
      this.setState({ isShowAddressPopup: true, addressData: addressData });
    }
  };
  addressOnChange = (e) => {
    let addressData = this.state.addressData;
    addressData[e.target.name] = e.target.value;
    this.setState({ addressData: addressData });
  };
  addressOnClick = () => {
    let logisticOrderData = this.state.logisticOrderData;
    let addressData = { ...this.state.addressData };
    logisticOrderData.address = addressData;
    this.setState({ logisticOrderData: logisticOrderData });
    this.closeAlertAddressModalCallBack();
  };
  closeAlertAddressModalCallBack = () => {
    this.setState({
      isShowAddressPopup: false,
      addressData: new AddressBean(),
    });
  };

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let addressData = this.state.addressData;
      addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCityList: showAutoCompleteList,
        addressData: addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readCityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let cityList = this.state.cityList;
      cityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["city"] = pdtType.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteCityList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCityBySearchString(searchString) {
    let cityData = this.state.cityList;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEventHandler = (e) => {
    let city = e.target.value;
    let city_List = this.state.cityList;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;

    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let addressData = this.state.addressData;

      addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteStateList: showAutoCompleteList,
        addressData: addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readStateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let stateList = this.state.stateList;
      stateList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["state"] = pdtType.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteStateList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      addressData: temp_addressData,
    });
  };
  readStateBySearchString(searchString) {
    let stateData = this.state.stateList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEventHandler = (e) => {
    let state = e.target.value;
    let state_List = this.state.stateList;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCountryList: showAutoCompleteList,
        addressData: addressData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readCountryBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let countryList = this.state.countryList;
      countryList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["country"] = pdtType.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
        }
      });
    }
    this.setState({
      addressData: temp_addressData,
    });
  };
  readCountryBySearchString(searchString) {
    let stateData = this.state.countryList;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEventHandler = (e) => {
    let country = e.target.value;
    let country_List = this.state.countryList;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;
      this.setState({
        addressData: temp_addressData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };

  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  /********* Line ******** */

  openLogisticLineForm = (e) => {
    if (e.detail <= 1) {
      if (
        !isEmpty(this.state.logisticOrderData) &&
        !isEmptyString(this.state.logisticOrderData.customerCode)
      ) {
        this.setState({ isShowLinePopup: true });
      } else {
        this.showToast("Customer Code Required", 2);
      }
    }
  };

  closeAlertModalCallBackLvl0 = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
      isShowAlertLvl0: isShowPopup,
      isShowColorLookup: false,
      showAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: [],
      isShowUomLookup: false,
      logisticOrderLineData: new LogisticOrderLineBean(),
      fabricStyleData: new FabricStyleBean(),
    });
    // this.clearLineData();
  };
  hideAlertCallBackLvl0 = (msgType, isDisplayed) => {
    this.setState({
      isShowAlertLvl0: isDisplayed,
    });
  };

  onLineChange = (e) => {
    let lineData = this.state.logisticOrderLineData;
    lineData[e.target.name] = e.target.value;
    this.setState({
      logisticOrderLineData: lineData,
    });
  };
  onFabricCodeChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let lineData = this.state.logisticOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let line = this.state.logisticOrderLineData;
      line.fabricStyleCode = "";
      line.fabricStyleName = "";
      line.colorCode = "";
      line.uomCode = "";
      line.inventoryUomCode = "";
      line.widthCode = "";
      line.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        logisticOrderLineData: line,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        isShowUomLookup: false,
        fabricStyleData: new FabricStyleBean(),
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    lineData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ logisticOrderLineData: lineData });
    // this.readSelectedFabricStyle(fabricStyleCode);
  };
  fabricCodeEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading FabricStyle...",
    });
    let fabricStyleCode = e.target.value;
    this.readSelectedFabricStyle(fabricStyleCode);
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let logisticOrderData = this.state.logisticOrderData;
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        if (fabricStyle.customerCode == logisticOrderData.customerCode) {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        }
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  getImageResponse = (response) => {
    let fabricStyleData = response.data.fabricStyle;
    if (fabricStyleData != null) {
      this.state.fabricStyleData = fabricStyleData;
      this.setState({
        fabricStyleData: fabricStyleData,
      });
    }
  };
  getFabricInages = (fabricStyleCode) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = fabricStyleCode;
    requestInput.lockRequired = false;
    requestInput.loadChildren = true;
    FabricStyleService.readFabricStyle(
      requestInput,
      this.getImageResponse,
      this.errorCallBack
    );
  };

  readSelectedFabricStyle = (fabricStyleCode) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = fabricStyleCode;
    requestInput.lockRequired = false;
    requestInput.loadChildren = true;
    FabricStyleService.readFabricStyle(
      requestInput,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  readFabricStyleResponse = (response) => {
    let fabricStyleData = response.data.fabricStyle;
    let currentFabricStyleSkuList = new Array();
    if (fabricStyleData != null) {
      this.state.fabricStyleData = fabricStyleData;
      this.setState({
        fabricStyleData: fabricStyleData,
        isShowColorLookup: true,
      });
      this.setFabricStyleDefaultValues(fabricStyleData);
    }
  };

  setFabricStyleDefaultValues = (fabricStyleData) => {
    let logisticOrderLineData = this.state.logisticOrderLineData;
    let logisticOrderData = this.state.logisticOrderData;
    logisticOrderLineData.fabricStyleCode = fabricStyleData.code;
    logisticOrderLineData.fabricStyleName = fabricStyleData.description;
    logisticOrderLineData.colorCode = "";
    logisticOrderLineData.uomCode = "";
    if (fabricStyleData.defaultLocationCode != null) {
      logisticOrderLineData.locationCode = fabricStyleData.defaultLocationCode;
    } else {
      logisticOrderLineData.locationCode = DEFAULT_WAREHOUSE;
    }
    logisticOrderLineData.widthCode = DEMO_VALUE;
    logisticOrderLineData.lineStatus =
      LogicConstants.LOGISTIC_ORDER_LINE_OPEN_STATUS;
    // logisticOrderLineData.uomConversionRate = 1;
    logisticOrderLineData.inventoryUomCode = fabricStyleData.inventoryUomCode;
    let colors = fabricStyleData.colors;
    this.setState({ isShowUomLookup: false });
    if (!isEmpty(colors)) {
      if (colors.length == 1) {
        logisticOrderLineData.colorCode = colors[0].fabricStyleColorCode;
        this.fabricStyleColorSelected(logisticOrderLineData.colorCode);

        this.setState({
          isShowColorLookup: false,
        });
      } else {
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
          });
        }
      }
    }

    this.setState({
      logisticOrderLineData: logisticOrderLineData,
      logisticOrderData: logisticOrderData,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      // isShowUomLookup: false,
    });
  };
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteColourList = true;
    let colorCode = e.target.value.toUpperCase();
    let lineData = this.state.logisticOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteColourList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteColourList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColourList;
      let line = this.state.logisticOrderLineData;
      line.colorCode = "";
      line.uomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        logisticOrderLineData: line,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowUomLookup: false,
      });
    } else if (showAutoCompleteList === true && colorCode !== "") {
      this.readFabricColourBySearchString(e.target.value);
    }
    lineData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ logisticOrderLineData: lineData });
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let line = this.state.logisticOrderLineData;

    line.colorCode = searchString;
    let colors = fabricStyle.colors;
    let finalColorList = [];
    colors.map((ent) => {
      let colorBean = new BaseBean();
      colorBean.code = ent.fabricStyleColorCode;
      colorBean.description = ent.fabricStyleColorName;
      finalColorList.push(colorBean);
    });
    let simpleAutoCompleteColorList = new Array();
    finalColorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let line = this.state.logisticOrderLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == line.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    line.colorCode = colorCode;
    if (!isEmpty(skuBean)) {
      line.skuNumber = skuBean.skuNumber;
      // line.uomCode = skuBean.uomCode;
    }
    let uomList = new Array();
    let sellingUOM_List = new Array();
    sellingUOM_List = fabricStyle.sellingUoms;
    sellingUOM_List.map((uom) => {
      const uomBean = new BaseBean();
      uomBean.code = uom.uomCode;
      uomBean.description = uom.uomCode.toLowerCase();
      uomBean.conversionRate = uom.conversionRate;
      uomList.push(uomBean);
    });
    if (!isEmptyArray(uomList)) {
      if (uomList.length == 1) {
        line.uomCode = uomList[0].code;
        line.uomConversionRate = uomList[0].conversionRate;
        this.setState({
          isShowUomLookup: false,
          uoms: uomList,
          // isDisabledFields:true,
        });
      } else {
        let uomLookupHandler = new GenericAttributeLookupHandler(
          uomList,
          "UOM"
        );
        this.setState({
          uomLookupHandler: uomLookupHandler,
          uoms: uomList,
          isShowUomLookup: true,
        });
      }
    }
    this.state.logisticOrderLineData = line;
    this.setState({ logisticOrderLineData: line });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  displayAutoCompleteColourList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteColourList: showAutoCompleteList });
  };
  getLogisticLine = (rowData) => {
    let logisticOrderLineData = { ...rowData };
    this.setState({
      logisticOrderLineData: logisticOrderLineData,
      isShowLinePopup: true,
    });
  };
  reArrangeLines = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  cancelLogisticOrderLine = (rowData) => {
    const logisticOrderData = { ...this.state.logisticOrderData };
    const row_Data = { ...rowData };
    let lines = new Array();
    if (!isEmptyArray(logisticOrderData.lines)) {
      // logisticOrderData.lines.map((ln) => {
      //   if (ln.lineNumber === row_Data.lineNumber) {
      let result = logisticOrderData.lines.filter(
        (ln) => ln.lineNumber != row_Data.lineNumber
      );
      this.reArrangeLines(result);
      logisticOrderData.lines = result;

      this.setState({
        logisticOrderData: logisticOrderData,
      });
      //   }
      // });
      // lines.push(...logisticOrderData.lines);
    }
    // var index = lines.indexOf(row_Data);
    // if (index > -1) {
    //   lines.splice(index, 1);
    // }
    // logisticOrderData.lines = lines;
  };
  validateLineData = (data) => {
    let isLineFound = false;
    let err_list = [];
    let errorMessage = "";
    if (data === null) {
      let errMsg = "Enter All Fields";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.fabricStyleCode)) {
        let errMsg = "fabricStyleCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.colorCode)) {
        let errMsg = "colorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (
        data.orderQuantity != null &&
        data.orderQuantity != undefined &&
        data.orderQuantity <= 0
      ) {
        let errMsg = "orderQuantity is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.uomCode)) {
        let errMsg = "UOMCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (data.uomConversionRate <= 0) {
        let errMsg = "UOM Conversion greater than zero";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl0: true,
      });
      isLineFound = false;
      this.setState({ errorList: err_list });
    } else {
      isLineFound = true;
    }
    return isLineFound;
  };
  getMaxLineNumber = () => {
    let maxLineNumber = 0;
    let logisticOrderData = this.state.logisticOrderData;
    if (!isEmpty(logisticOrderData) && !isEmptyArray(logisticOrderData.lines)) {
      logisticOrderData.lines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };

  calculateNoOfPallets = (data) => {
    let noOfPallets = 0;
    if (!isEmptyArray(data.lines)) {
      data.lines.map((ln) => {
        if (ln.numberOfPallets != null && ln.numberOfPallets != undefined) {
          noOfPallets = noOfPallets + parseInt(ln.numberOfPallets);
        }
      });
    }
    data.totalNumberOfPallets = noOfPallets;
    return data;
  };

  addOrUpdateLine = (e) => {
    if (e.detail == 1) {
      const logisticOrderData = { ...this.state.logisticOrderData };
      const lines = [...this.state.logisticOrderData.lines];
      const logisticOrderLineData = { ...this.state.logisticOrderLineData };
      logisticOrderLineData.companyCode = this.companyCode;
      let isValid = false;
      isValid = this.validateLineData(logisticOrderLineData);
      if (isValid) {
        let isLineFound = false;
        var lineNumber = this.getMaxLineNumber();
        lines.map((line, i) => {
          if (line.lineNumber == logisticOrderLineData.lineNumber) {
            logisticOrderLineData.lineNumber = line.lineNumber;
            logisticOrderLineData.isFetched = line.isFetched;
            lines[i] = logisticOrderLineData;
            isLineFound = true;
          }
        });
        if (!isLineFound) {
          logisticOrderLineData.lineNumber = ++lineNumber;
          lines.push(logisticOrderLineData);
        }
        logisticOrderData.lines = lines;
        this.calculateNoOfPallets(logisticOrderData);
        this.setState({ logisticOrderData: logisticOrderData });
        this.closeAlertModalCallBackLvl0(false);
        this.clearLineData(e);
      }
    }
  };
  clearLineData = (e) => {
    if (e.detail == 1) {
      let logisticOrderLineData = this.state.logisticOrderLineData;
      logisticOrderLineData = new LogisticOrderLineBean();
      this.setState({
        logisticOrderLineData: logisticOrderLineData,
        isShowColorLookup: false,
        isShowUomLookup: false,
      });
    }
  };
  validADQty = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.fabricStyleCode)) {
        let errMsg = "fabricStyleCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      } else if (isEmptyString(data.colorCode)) {
        let errMsg = "color is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl: true,
      });
      isValid = false;
      this.setState({ errorList: err_list });
    } else {
      isValid = true;
    }
    return isValid;
  };
  calculateAdjQuanity = (data) => {
    var adjquantity = 0;
    data.adjustmentLines.map((quantity) => {
      adjquantity += parseInt(quantity.adjustedQuantity);
    });
    if (
      !isEmpty(this.state.logisticOrderData) &&
      !isEmptyArray(this.state.logisticOrderData.lines)
    )
      this.state.logisticOrderData.lines.map((line) => {
        if ((data.lineNumber = line.lineNumber)) {
          line.adjustedQuantity = adjquantity;
        }
      });
    const logisticOrderLineData = { ...this.state.logisticOrderLineData };
    logisticOrderLineData.adjustedQuantity = adjquantity;
    this.setState({ logisticOrderLineData: logisticOrderLineData });
  };
  adjContinueHandler = (e) => {
    if (e.detail == 1) {
      const logisticOrderLineData = { ...this.state.logisticOrderLineData };
      const adjLines = [...this.state.adjLines];
      logisticOrderLineData.adjustmentLines = [...adjLines];
      this.state.logisticOrderLineData = logisticOrderLineData;
      this.setState({
        logisticOrderLineData: logisticOrderLineData,
      });
      setTimeout(() => {
        this.calculateAdjQuanity(logisticOrderLineData);
      }, 500);
      this.closeAlertModalCallBackLvl1(false);
      this.clearAdjLines(e);
    }
  };
  adjustedQuantityHandler = (e) => {
    if (e.detail === 1) {
      const logisticOrderLineData = this.state.logisticOrderLineData;
      let adjLines = new Array();
      if (!isEmptyArray(logisticOrderLineData.adjustmentLines)) {
        adjLines = logisticOrderLineData.adjustmentLines;
      }
      let isValid = false;
      isValid = this.validADQty(logisticOrderLineData);
      if (isValid) {
        this.setState({
          isShowAdjustedQuantityPopup: true,
          adjLines: adjLines,
        });
      }
    }
  };
  hideAlertCallBackLvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl1: false });
  };
  closeAlertModalCallBackLvl1 = () => {
    this.setState({
      isShowAdjustedQuantityPopup: false,
      isShowItemImagePopup: false,
    });
    this.hideAlertCallBackLvl1();
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: false });
  };
  closeAlertModalCallBackLvl5 = () => {
    this.setState({
      isShowItemDocPopup: false,
    });
    this.hideAlertCallBackLvl5();
  };
  onAdjustmentReasonChange = (e) => {
    let reasonCode = e.target.value;
    this.state.showAutoCompleteReasonList = true;
    let adjustmentData = this.state.adjustmentData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;
    if (isEmpty(reasonCode)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      adjustmentData.code = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        adjustmentData: adjustmentData,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && reasonCode !== "") {
      this.readAdjReasonBySearchString(reasonCode);
    }
    adjustmentData[e.target.name] = e.target.value;
    this.setState({ adjustmentData: adjustmentData });
    this.readAdjustReason(reasonCode);
  };
  readAdjustReason = (reasonCode) => {
    let reasonBean = null;
    this.state.adjReasons.map((ln) => {
      if (ln.code === reasonCode) {
        reasonBean = ln;
      }
    });
    if (!isEmpty(reasonBean)) {
      let adjustmentData = this.state.adjustmentData;
      adjustmentData.code = reasonBean.code;
      adjustmentData.description = reasonBean.description;
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      this.setState({
        adjustmentData: adjustmentData,
        showAutoCompleteReasonList: showAutoCompleteList,
      });
    }
  };
  readAdjReasonBySearchString = (searchString) => {
    const adjReasons = this.state.adjReasons;
    let simpleAutoCompleteList = new Array();
    if (!isEmptyArray(adjReasons)) {
      adjReasons.map((sp) => {
        let reasonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(reasonBean);
      });
    }
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(searchString.toLowerCase()) > -1
    );
    this.setState({
      reasonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  adjReasonEnterKeyEventHandler = (e) => {
    this.readAdjustReason(e.target.value);
    this.setState({
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteAdjReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  onAdjustmentChange = (e) => {
    let adjustmentData = this.state.adjustmentData;
    adjustmentData[e.target.name] = e.target.value;
    this.setState({ adjustmentData: adjustmentData });
  };

  validateAdjData = (data) => {
    let isLineFound = false;
    let err_list = [];
    let errorMessage = "";
    if (data === null) {
      let errMsg = "Enter All Fields";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.code)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.adjustedQuantity)) {
        let errMsg = "Quantity is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.uomCode)) {
        let errMsg = "UOM is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl0: true,
      });
      isLineFound = false;
      this.setState({ errorList: err_list });
    } else {
      isLineFound = true;
    }
    return isLineFound;
  };
  getMaxAdjLineNumber = () => {
    let maxLineNumber = 0;
    let adjLines = this.state.adjLines;
    if (!isEmptyArray(adjLines)) {
      adjLines.map((line) => {
        if (line.adjustmentLineNumber > maxLineNumber) {
          maxLineNumber = line.adjustmentLineNumber;
        }
      });
    }
    return maxLineNumber;
  };

  deleteAdjustmentLine = (e, rowData) => {
    if (e.detail == 1) {
      let adjLines = [...this.state.adjLines];

      if (!isEmptyArray(adjLines)) {
        var index = adjLines.indexOf(rowData);
        if (index > -1) {
          adjLines.splice(index, 1);
        }
      }

      this.setState({ adjLines: adjLines });
    }
  };
  adjLineHandler = (e, rowData) => {
    if (e.detail == 1) {
      const row_Data = { ...rowData };
      this.setState({
        adjustmentData: row_Data,
      });
    }
  };
  addOrUpdateAdj = (e) => {
    if (e.detail <= 1) {
      const adjustmentData = { ...this.state.adjustmentData };
      const adjLines = [...this.state.adjLines];
      adjustmentData.companyCode = this.companyCode;
      let isValid = false;
      isValid = this.validateAdjData(adjustmentData);
      if (isValid) {
        let isLineFound = false;
        var lineNumber = this.getMaxAdjLineNumber();
        if (!isEmptyArray(adjLines)) {
          adjLines.map((line, i) => {
            if (
              line.adjustmentLineNumber == adjustmentData.adjustmentLineNumber
            ) {
              adjustmentData.adjustmentLineNumber = line.adjustmentLineNumber;
              adjustmentData.isFetched = line.isFetched;
              adjLines[i] = adjustmentData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          adjustmentData.adjustmentLineNumber = ++lineNumber;
          adjLines.push(adjustmentData);
        }
        this.setState({ adjLines: adjLines });
        this.clearAdjLines(e);
      }
    }
  };
  clearAdjLines = (e) => {
    if (e.detail <= 1)
      this.setState({ adjustmentData: new LogisticOrderLineAdjustmentBean() });
  };
  onUOMCodeChange = (e) => {
    let uomCode = e.target.value;
    this.state.showAutoCompleteUOMList = true;
    let logisticOrderLineData = this.state.logisticOrderLineData;
    let showAutoCompleteList = this.state.showAutoCompleteUOMList;
    if (isEmpty(uomCode)) {
      this.state.showAutoCompleteUOMList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMList;
      let logisticOrderLineData = this.state.logisticOrderLineData;
      logisticOrderLineData.uomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        logisticOrderLineData: logisticOrderLineData,
        uomPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && uomCode !== "") {
      this.readUomCodeBySearchString(uomCode);
    }
    if (e.target.name == "uomCode") {
      logisticOrderLineData["uomCode"] = e.target.value;
      let uom_List = this.state.uoms;
      uom_List.map((uom) => {
        if (uom.code == e.target.value) {
          logisticOrderLineData["uomCode"] = uom.code;
          this.state.showAutoCompleteUOMList = false;
          let showAutoCompleteList = this.state.showAutoCompleteUOMList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ logisticOrderLineData: logisticOrderLineData });
  };
  readUomCodeBySearchString(searchString) {
    let uom_List = this.state.uoms;

    let simpleAutoCompleteList = new Array();
    if (uom_List.length > 0 && uom_List != null) {
      uom_List.map((uom) => {
        let simpleItemBean = {
          code: uom.code,
          description: uom.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ uomPageListForAutoCompleteList: filteredSuggestions });
  }

  uomEnterKeyEvent = (e) => {
    let logisticOrderLineData = this.state.logisticOrderLineData;
    logisticOrderLineData["uomCode"] = e.target.value;
    let uom_List = this.state.uoms;
    let uomBean = null;
    uom_List.map((uom) => {
      if (uom.code == e.target.value) {
        uomBean = uom;
      }
    });
    if (!isEmpty(uomBean)) {
      let logisticOrderLineData = this.state.logisticOrderLineData;
      logisticOrderLineData.uomCode = uomBean.code;
      logisticOrderLineData.uomConversionRate = uomBean.conversionRate;
      this.setState({
        logisticOrderLineData: logisticOrderLineData,
        uomPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteUomList: showAutoCompleteList });
  };
  getCurrentTime = () => {
    const logisticOrderData = { ...this.state.logisticOrderData };
    let currentDate = new Date();
    let time = currentDate.getHours() + ":" + currentDate.getMinutes();
    time = time.toLocaleString();
    logisticOrderData.expectedReceivedTime = time;
    this.setState({ logisticOrderData: logisticOrderData });
  };
  getHeaderView() {
    return (
      <LogisticOrderEntryForm
        {...this.state}
        readSelectedFabricStyle={this.readSelectedFabricStyle}
        onChange={this.onChange}
        customerOnChange={this.customerOnChange}
        customerEnterKeyEventHandler={this.customerEnterKeyEventHandler}
        displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
        addressClickHandler={this.addressClickHandler}
        openLogisticLineForm={this.openLogisticLineForm}
        getLogisticLine={this.getLogisticLine}
        cancelLogisticOrderLine={this.cancelLogisticOrderLine}
        onLocationChange={this.onLocationChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        closeAlertModalCallBackLvl0={this.closeAlertModalCallBackLvl0}
        hideAlertCallBackLvl0={this.hideAlertCallBackLvl0}
        onFabricCodeChange={this.onFabricCodeChange}
        fabricCodeEnterKeyEventHandler={this.fabricCodeEnterKeyEventHandler}
        displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
        onFabricColourCodeChange={this.onFabricColourCodeChange}
        fabricColourEnterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
        displayAutoCompleteColourList={this.displayAutoCompleteColourList}
        onLineChange={this.onLineChange}
        addOrUpdateLine={this.addOrUpdateLine}
        adjustedQuantityHandler={this.adjustedQuantityHandler}
        clearLineData={this.clearLineData}
        onUOMCodeChange={this.onUOMCodeChange}
        uomEnterKeyEvent={this.uomEnterKeyEvent}
        displayAutoCompleteUomList={this.displayAutoCompleteUomList}
        lnkFabricModule={this.lnkFabricModule}
        openItemInvPositionInq={this.openItemInvPositionInq}
        openItemCurrentInvInq={this.openItemCurrentInvInq}
        openItemPurchaseHistoryInq={this.openItemPurchaseHistoryInq}
        getFabricInages={this.getFabricInages}
        getCurrentTime={this.getCurrentTime}
        closeAlertModalCallBackLvl1={this.closeAlertModalCallBackLvl1}
        hideAlertCallBackLvl1={this.hideAlertCallBackLvl1}
        closeAlertModalCallBackLvl5={this.closeAlertModalCallBackLvl5}
        hideAlertCallBackLvl5={this.hideAlertCallBackLvl5}
        showToast={this.show_Toast}
        openImagePopup={this.openImagePopup}
        deleteItemImage={this.deleteItemImage}
        uploadImage={this.uploadImage}
        setMainUrl={this.setMainUrl}
        setWebUrl={this.setWebUrl}
        setFrontUrl={this.setFrontUrl}
        setBackUrl={this.setBackUrl}
        setMainImg={this.setMainImg}
        setWebImg={this.setWebImg}
        setFrontImg={this.setFrontImg}
        setBackImg={this.setBackImg}
        openDocPopup={this.openDocPopup}
        addorUpdateDocData={this.addorUpdateDocData}
        uploadDoc={this.uploadDoc}
        deleteDoc={this.deleteDoc}
        setDoc1Url={this.setDoc1Url}
        setDoc1Name={this.setDoc1Name}
        setDoc1Data={this.setDoc1Data}
        setDoc2Url={this.setDoc2Url}
        setDoc2Name={this.setDoc2Name}
        setDoc2Data={this.setDoc2Data}
        setDoc3Url={this.setDoc3Url}
        setDoc3Name={this.setDoc3Name}
        setDoc3Data={this.setDoc3Data}
        setDoc4Url={this.setDoc4Url}
        setDoc4Name={this.setDoc4Name}
        setDoc4Data={this.setDoc4Data}
        disableUpdatableFields={this.state.disableUpdatableFields}
        lnkFabricModuleV1 = {this.lnkFabricModuleV1}
      //  openItemPurchaseHistoryInq = {this.openItemPurchaseHistoryInq}
        // openItemCurrentInvInq = {this.openItemCurrentInvInq}
        // openItemInvPositionInq = {this.openItemInvPositionInq}
        // openItemPurchaseHistoryInq = {this.openItemPurchaseHistoryInq}
     //   openItemCurrentInvInq = {this.openItemCurrentInvInq}
    //  openItemInvPositionInq = {this.openItemInvPositionInq}

      />
    );
  }
  getHistoryView() {
    return <LogisticOrderHistoryForm {...this.state} />;
  }
  getImageView = () => {
    return (
      <MutilpleImages
        {...this.state}
        logisticOrderData={this.state.logisticOrderData}
        onChange={this.onChange}
        showToast={this.showToast}
        setMultiImageUrl={this.setMultiImageUrl}
        setMultiImgData={this.setMultiImgData}
        uploadMutiImage={this.uploadMutiImage}
        deleteMutipleImage={this.deleteMutipleImage}
        //   onImageChange={this.onImageChange}
        addImageLines={this.addImageLines}
        clearImageLines={this.clearImageLines}

      />
    );
  }
  getDocumentView = () => {
    return (
      <MutilpleDocuments
        {...this.state}
        logisticOrderData={this.state.logisticOrderData}
        documents={this.state.documents}
        // onChange={this.onChange}
        showToast={this.showToast}
        uploadMutiDouments={this.uploadMutiDouments}
        uploadMutiDoumentsUrl={this.uploadMutiDoumentsUrl}
        deleteMultiDocument={this.deleteMultiDocument}
      />
    );
  }

  //--------------------------------------------------------Image And Document------------------------

  setMultiImageUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Url: url,
      });
    }, 300);
  };
  setMultiImgData = (data) => {
    // this.setState({

    setTimeout(() => {
      this.setState({
        images: data,
      });
    }, 400);
    //   images: data,
    // });
  };
  uploadMutiImage = (images) => {
    let logisticOrderData = this.state.logisticOrderData;
    let receiptImages = new Array();
    let imageData = null;
    for (const img of images) {
      if (!img.isFetched && !img.isDeleted) {
        imageData = new LogisticOrderImageBean();
        if (!isEmpty(img.imageCode)) {
          imageData.imageCode = img.imageCode;
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
          imageData.isFetched = true;
          imageData.isApplied = true;
        } else {
          imageData.imageOritinalname = img.name;
          imageData.imageName = img.name;
        }
        imageData.companyCode = this.companyCode;
        imageData.logisticOrderNumber = logisticOrderData.code;
        receiptImages.push(imageData);
      } else {
        if (img.isFetched == true) {
          receiptImages.push(img);
        }
      }
    }
    logisticOrderData.orderImages = receiptImages;
    //   this.state.images = receiptImages;

    this.setState({
      logisticOrderData: logisticOrderData,
      images: images,
    });
  };
  deleteMutipleImage = (tempIndex) => {
    let orderImages = this.state.logisticOrderData.orderImages;
    if (!isEmptyArray(orderImages)) {
      for (let j = 0; j < orderImages.length; j++) {
        if (j === tempIndex) {
          if (orderImages[j].isFetched == true) {
            orderImages[j].deleted = true; // Change the value at index 2
            orderImages[j].isDeleted = true;
          } else {
            orderImages.splice(j, 1); // Change the value at index 2
            this.state.images.splice(j, 1);
          }
        }
      }
    }
    this.state.logisticOrderData.orderImages = orderImages;
  };
  addImageLines = (imageEntity) => {
    let logisticOrderData = this.state.logisticOrderData;
    logisticOrderData.orderImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = imageEntity.tags;
        det.notesCommunication = imageEntity.notesCommunication;
      }
    });
    this.setState({
      logisticOrderData: logisticOrderData,
    });
  };
  // clearImageLines
  clearImageLines = (imageEntity) => {
    let logisticOrderData = this.state.logisticOrderData;
    logisticOrderData.orderImages.map((det) => {
      if (det.imageName == imageEntity.imageName) {
        det.tags = "";
        det.notesCommunication = "";
      }
    });
    this.setState({
      logisticOrderData: logisticOrderData,
    });
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showToast = (msg, type) => {
    let errList = [];
    if (type === 1) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (type === 2) {
      errList.push(msg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadMutiDouments = (docs) => {
    let logisticOrderData = this.state.logisticOrderData;
    let documents = new Array();
    let docmentData = null;
    for (const doc of docs) {
      if (!doc.isFetched) {
        docmentData = new LogisticOrderDocumentBean();
        docmentData.documentOriginalname = doc.name;
        docmentData.documentName = doc.name;
        docmentData.companyCode = this.companyCode;
        docmentData.logisticOrderNumber = logisticOrderData.code;
        docmentData.documentPath = DOCUMENT_CHANGED;
        documents.push(docmentData);
      } else {
        documents.push(doc);
      }
    }
    logisticOrderData.logisticOrderDocuments = documents;
    this.setState({
      logisticOrderData: logisticOrderData,
      documents: docs,
    });
  };
  uploadMutiDoumentsUrl = (url) => {
    setTimeout(() => {
      this.setState({
        preview_Docs: url,
      });
    }, 400);
  };

  deleteMultiDocument = (rowData) => {
    let docs = this.state.logisticOrderData.logisticOrderDocuments;
    if (!isEmptyArray(docs)) {
      for (let j = 0; j < docs.length; j++) {
        if (docs[j].documentName === rowData.documentName) {
          if (docs[j].isFetched == true) {
            docs[j].deleted = true; // Change the value at index 2
            docs[j].isDeleted = true;
          } else {
            docs.splice(j, 1); // Change the value at index 2
            this.state.documents.splice(j, 1);
          }
        }
      }
    }
    this.state.logisticOrderData.logisticOrderDocuments = docs;
  };

  //-----------------------------------*************************************-------------------------------
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  lnkFabricModule = (e) => {
    if (e.detail === 1) {
      let logisticOrderLineData = this.state.logisticOrderLineData;
      let code = logisticOrderLineData.fabricStyleCode;
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  lnkFabricModuleV1 = (e,code) => {
    if (e.detail === 1) {
     // let logisticOrderLineData = this.state.logisticOrderLineData;
      //let code = code;
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  openItemPurchaseHistoryInq = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowFabricPurchaseHistoryInq: true,
          moduleForPopup: (
            <PopupFabricPurchaseHistoryInq
              fabricCode={code}
              // vendorCode={vendorCode}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openItemInvPositionInq = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemInventoryPositionInq: true,
          moduleForPopup: (
            <PopupFabricInventoryPositionInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  openItemCurrentInvInq = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
        this.setState({
          isShowItemCurrentInventoryInq: true,
          moduleForPopup: (
            <PopupItemCurrentInventoryInq
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricModule: isOpen,
      isShowItemInventoryPositionInq: isOpen,
      isShowItemCurrentInventoryInq: isOpen,
      isShowFabricPurchaseHistoryInq: isOpen,

      moduleForPopup: [],
    });
  };
  getLogisticLineImagePathMain = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Main" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getLogisticLineImagePathWeb = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Web" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;
      if (mainImage.deleted) {
        imageURL = "";
      }
      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getLogisticLineImagePathFront = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Front" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };
  getLogisticLineImagePathBack = (fabricStyle) => {
    if (fabricStyle == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages == null) {
      return null;
    } else if (fabricStyle.fabricStyleImages.length <= 0) {
      return null;
    } else {
      let mainImage = new FabricStyleImageBean();
      for (var i = 0; i < fabricStyle.fabricStyleImages.length; i++) {
        if (
          fabricStyle.fabricStyleImages[i].imagePart == "Back" &&
          fabricStyle.fabricStyleImages[i].deleted == false
        ) {
          mainImage = fabricStyle.fabricStyleImages[i];
        }
      }
      let serviceURL = this.getFabricImageURL();
      let imageName = mainImage.imageName;
      let imageURL = serviceURL + imageName;

      if (mainImage.deleted) {
        imageURL = "";
      }

      if (imageName == "") {
        return null;
      }
      if (imageURL == "") {
        return null;
      }
      return imageURL;
    }
  };

  getFabricImageURL = () => {
    const { appData } = this.context;
    let serviceURL = appData.serviceURL;
    let imageURL = serviceURL + "/image?file=";
    return imageURL;
  };

  /* image popup */
  openImagePopup = (e) => {
    this.setState({ isShowItemImagePopup: true });
  };
  deleteItemImage = (imagePart) => {
    const entity__Data = { ...this.state.logisticOrderData };

    if (!isEmptyArray(entity__Data.orderImages)) {
      entity__Data.orderImages.map((img) => {
        if (img.imagePart === imagePart) {
          img.imageOritinalname = null;
          img.isDeleted = true;
        }
      });
    }

    if (imagePart === MAIN_IMAGE_PART) {
      this.setMainUrl("");
    } else if (imagePart == WEB_IMAGE_PART) {
      this.setWebUrl("");
    } else if (imagePart == FRONT_IMAGE_PART) {
      this.setFrontUrl("");
    } else if (imagePart == BACK_IMAGE_PART) {
      this.setBackUrl("");
    }

    this.setState({ logisticOrderData: entity__Data });
  };
  uploadImage = (file, imagePart) => {
    if (file) {
      const entity__Data = { ...this.state.logisticOrderData };

      let itemImg__Data = null;

      if (!isEmptyArray(entity__Data.orderImages)) {
        entity__Data.orderImages.map((img) => {
          if (img.imagePart === imagePart) {
            itemImg__Data = { ...img };
          }
        });
      }
      if (!isEmpty(itemImg__Data)) {
        itemImg__Data.imageOritinalname = file.name;
      } else {
        itemImg__Data = new LogisticOrderImageBean();
        // itemImg__Data = {};
        itemImg__Data.imagePart = imagePart;
        itemImg__Data.imageOritinalname = file.name;
        itemImg__Data.imageName = file.name;
        itemImg__Data.companyCode = this.companyCode;
        itemImg__Data.logisticOrderNumber = entity__Data.code;
        entity__Data.orderImages.push(itemImg__Data);
      }

      this.setState({
        logisticOrderData: entity__Data,
      });
    }
  };

  imageUploadResponse = (response) => { };

  toServer = (file, fileName) => {
    let image = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", image);
    LogisticOrderService.logisticOrderImageUpload(
      formData,
      this.imageUploadResponse,
      this.errorCallBack
    );
  };
  uploadImagesToServer = () => {
    const entity__Data = { ...this.state.logisticOrderData };
    const images = this.state.images;
    if (!isEmptyArray(entity__Data.orderImages)) {
      entity__Data.orderImages.map((img) => {
        if (img.isDeleted != true && img.isFetched != true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        } else if (img.isFetched == true && img.isApplied == true) {
          images.map((imgData) => {
            if (img.imageOritinalname == imgData.name) {
              this.toServer(imgData, img.imageName);
            }
          });
        }
      });
    }
    // }
  };
  // uploadImagesToServer = () => {
  //   const entity__Data = { ...this.state.logisticOrderData };

  //   const main__Img = this.state.mainImgData;
  //   const web__Img = this.state.webImgData;
  //   const front__Img = this.state.frontImgData;
  //   const Back__Img = this.state.BackImgData;

  //   if (!isEmptyArray(entity__Data.orderImages)) {
  //     entity__Data.orderImages.map((imgData) => {
  //       if (imgData.imagePart == MAIN_IMAGE_PART && imgData.isDeleted != true) {
  //         if (main__Img != null) this.toServer(main__Img, imgData.imageName);
  //       } else if (
  //         imgData.imagePart == WEB_IMAGE_PART &&
  //         imgData.isDeleted != true
  //       ) {
  //         if (web__Img != null) this.toServer(web__Img, imgData.imageName);
  //       } else if (
  //         imgData.imagePart == FRONT_IMAGE_PART &&
  //         imgData.isDeleted != true
  //       ) {
  //         if (front__Img != null) this.toServer(front__Img, imgData.imageName);
  //       } else if (
  //         imgData.imagePart == BACK_IMAGE_PART &&
  //         imgData.isDeleted != true
  //       ) {
  //         if (Back__Img != null) this.toServer(Back__Img, imgData.imageName);
  //       }
  //     });
  //   }
  // };

  getImageURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "logisticOrderImages?file=";
  };

  setMainUrl = (url) => {
    setTimeout(() => {
      this.setState({
        mainImageUrl: url,
      });
    }, 2000);
  };
  setWebUrl = (url) => {
    setTimeout(() => {
      this.setState({
        webImageUrl: url,
      });
    }, 2000);
  };
  setFrontUrl = (url) => {
    setTimeout(() => {
      this.setState({
        frontImageUrl: url,
      });
    }, 2000);
  };
  setBackUrl = (url) => {
    setTimeout(() => {
      this.setState({
        backImageUrl: url,
      });
    }, 2000);
  };
  setMainImg = (data) => {
    this.setState({
      mainImgData: data,
    });
  };
  setWebImg = (data) => {
    this.setState({
      webImgData: data,
    });
  };
  setFrontImg = (data) => {
    this.setState({
      frontImgData: data,
    });
  };
  setBackImg = (data) => {
    this.setState({
      BackImgData: data,
    });
  };

  /* document popup */

  openDocPopup = () => {
    this.setState({
      isShowItemDocPopup: true,
    });
  };

  addorUpdateDocData = () => {
    this.setState({
      isShowItemDocPopup: false,
    });
  };

  uploadDoc = (file, type) => {
    if (file) {
      const entity__Data = { ...this.state.logisticOrderData };

      let itemDoc__Data = null;

      // let documentNumber = 1;
      if (!isEmptyArray(entity__Data.logisticOrderDocuments)) {
        entity__Data.logisticOrderDocuments.map((doc) => {
          if (doc.documentNumber == type) {
            doc.isDeleted = false;
            // doc.documentPath = DOCUMENT_CHANGED;
            doc.documentName = file.name;
            // doc.documentOriginalname = file.name;
            doc.documentOriginalname = DOCUMENT_CHANGED;
            itemDoc__Data = { ...doc };
          }
          // documentNumber++;
        });
      }
      if (!isEmpty(itemDoc__Data)) {
        // itemDoc__Data.documentPath = DOCUMENT_CHANGED;
        // itemDoc__Data.documentName = file.name;
        // itemDoc__Data.documentOriginalname = file.name;
        // itemDoc__Data.isDeleted = false;
      } else {
        itemDoc__Data = new LogisticOrderDocumentBean();
        // itemDoc__Data = {};
        itemDoc__Data.logisticOrderNumber = entity__Data.code;
        itemDoc__Data.companyCode = this.companyCode;
        // itemDoc__Data.documentOriginalname = file.name;
        itemDoc__Data.documentNumber = type;
        // itemDoc__Data.documentPath = DOCUMENT_CHANGED;
        itemDoc__Data.documentOriginalname = DOCUMENT_CHANGED;
        itemDoc__Data.documentName = file.name;
        itemDoc__Data.isDeleted = false;

        entity__Data.logisticOrderDocuments.push(itemDoc__Data);
      }
      this.setState({
        pickTicketData: entity__Data,
      });
    }
  };

  // uploadDoc = (file, type) => {
  //   if (file) {
  //     const entity__Data = { ...this.state.logisticOrderData };

  //     let itemDoc__Data = null;

  //     // let documentNumber = 1;
  //     if (!isEmptyArray(entity__Data.logisticOrderDocuments)) {
  //       entity__Data.logisticOrderDocuments.map((doc) => {
  //         if (doc.documentNumber == type) {
  //           itemDoc__Data = { ...doc };
  //         }
  //         // documentNumber++;
  //       });
  //     }
  //     if (!isEmpty(itemDoc__Data)) {
  //       itemDoc__Data.documentPath = DOCUMENT_CHANGED;
  //       itemDoc__Data.documentName = file.name;
  //       itemDoc__Data.documentOriginalname = file.name;
  //     } else {
  //       itemDoc__Data = new LogisticOrderDocumentBean();
  //       // itemDoc__Data = {};
  //       itemDoc__Data.logisticOrderNumber = entity__Data.code;
  //       itemDoc__Data.companyCode = this.companyCode;
  //       itemDoc__Data.documentOriginalname = file.name;
  //       itemDoc__Data.documentNumber = type;
  //       itemDoc__Data.documentPath = DOCUMENT_CHANGED;
  //       itemDoc__Data.documentName = file.name;

  //       entity__Data.logisticOrderDocuments.push(itemDoc__Data);
  //     }

  //     this.setState({
  //       logisticOrderData: entity__Data,
  //     });
  //   }
  // };
  deleteDoc = (type) => {
    const entity__Data = { ...this.state.logisticOrderData };

    if (!isEmptyArray(entity__Data.logisticOrderDocuments)) {
      entity__Data.logisticOrderDocuments.map((doc) => {
        if (doc.documentNumber === type) {
          doc.documentName = "";
          doc.documentPath = "";
          doc.isDeleted = true;
        }
      });
    }

    if (type == 1) {
    } else if (type == 2) {
    } else if (type == 3) {
    } else if (type == 4) {
    }
    this.setState({ logisticOrderData: entity__Data });
  };

  documentUploadResponse = (response) => { };

  docToServer = (file, fileName) => {
    let document = new File([file], `${fileName}`, { type: file.type });
    const formData = new FormData();
    formData.append("file", document);
    LogisticOrderService.logisticOrderDocUpload(
      formData,
      this.documentUploadResponse,
      this.errorCallBack
    );
  };
  uploadMultiDocsToServer = () => {
    const receiptData = { ...this.state.logisticOrderData };
    const documents = this.state.documents;
    if (!isEmptyArray(receiptData.logisticOrderDocuments)) {
      receiptData.logisticOrderDocuments.map((doc) => {
        if (doc.isDeleted != true && doc.isFetched != true) {
          documents.map((docData) => {
            if (doc.documentOriginalname == docData.name) {
              this.docToServer(docData, doc.documentName);
            }
          });
        }
      });
    }
  };
  uploadDocsToServer = () => {
    const entity__Data = { ...this.state.logisticOrderData };

    const doc1__data = this.state.doc1Data;
    const doc2__data = this.state.doc2Data;
    const doc3__data = this.state.doc3Data;
    const doc4__data = this.state.doc4Data;

    if (!isEmptyArray(entity__Data.logisticOrderDocuments)) {
      entity__Data.logisticOrderDocuments.map((doc) => {
        if (doc.documentNumber == 1 && doc.isDeleted != true) {
          if (doc1__data != null)
            this.docToServer(doc1__data, doc.documentName);
        } else if (doc.documentNumber == 2 && doc.isDeleted != true) {
          if (doc2__data != null)
            this.docToServer(doc2__data, doc.documentName);
        } else if (doc.documentNumber == 3 && doc.isDeleted != true) {
          if (doc3__data != null)
            this.docToServer(doc3__data, doc.documentName);
        } else if (doc.documentNumber == 4 && doc.isDeleted != true) {
          if (doc4__data != null)
            this.docToServer(doc4__data, doc.documentName);
        }
      });
    }
  };

  getDocURL = () => {
    const { appData } = this.context;
    return appData.serviceURL + "/" + "logisticOrderDocs?file=";
    // return appData.serviceURL + "/" + process.env.REACT_APP_ITEM_DOC_PATH;
  };
  setDoc1Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc1Url: url,
      });
    }, 2000);
  };
  setDoc2Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc2Url: url,
      });
    }, 2000);
  };
  setDoc3Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc3Url: url,
      });
    }, 2000);
  };
  setDoc4Url = (url) => {
    setTimeout(() => {
      this.setState({
        doc4Url: url,
      });
    }, 2000);
  };
  setDoc1Name = (name) => {
    this.setState({
      doc1Name: name,
    });
  };
  setDoc2Name = (name) => {
    this.setState({
      doc2Name: name,
    });
  };
  setDoc3Name = (name) => {
    this.setState({
      doc3Name: name,
    });
  };
  setDoc4Name = (name) => {
    this.setState({
      doc4Name: name,
    });
  };

  setDoc1Data = (data) => {
    this.setState({
      doc1Data: data,
    });
  };
  setDoc2Data = (data) => {
    this.setState({
      doc2Data: data,
    });
  };
  setDoc3Data = (data) => {
    this.setState({
      doc3Data: data,
    });
  };
  setDoc4Data = (data) => {
    this.setState({
      doc4Data: data,
    });
  };

  render() {
    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricPurchaseHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemInventoryPositionInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemCurrentInventoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : this.state.isSpecialViewModeError ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editLogisticOrder}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.logisticOrderLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          disabled={this.state.disabled}
          selectButtonClick={this.selectButtonClick}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isLogisticOrderListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
              extend_toolbar={
                <>
                  {this.state.isShowExcelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.generateExcel(e)}
                    >
                      <ExcelIcon />
                      Excel
                    </Button>
                  )}
                  {this.state.isShowUnApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.unApproveLogisticOrder(e)}
                    >
                      UnApprove
                    </Button>
                  )}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approveLogisticOrder(e)}
                    >
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelLogisticOrder(e)}
                    >
                      Cancel
                    </Button>
                  )}
                </>
              }
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={this.state.moduleOrderStatus}
          />
        )}

        {!this.state.isShowNodes &&
          !this.state.isLogisticOrderListFormOpen &&
          this.state.isLogisticOrderEntryFormOpen &&
          !this.state.isLogisticOrderHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticOrderListFormOpen &&
          this.state.isLogisticOrderEntryFormOpen &&
          !this.state.isLogisticOrderHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticOrderListFormOpen &&
          !this.state.isLogisticOrderEntryFormOpen &&
          this.state.isLogisticOrderHistoryFormOpen &&
          this.getHistoryView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticOrderListFormOpen &&
          !this.state.isLogisticOrderEntryFormOpen &&
          !this.state.isLogisticOrderHistoryFormOpen &&
          this.state.isLogisticOrderImageFormOpen &&
          !this.state.isLogisticOrderDocumentFormOpen &&
          this.getImageView()}
        {this.state.isShowNodes &&
          !this.state.isLogisticOrderListFormOpen &&
          !this.state.isLogisticOrderEntryFormOpen &&
          !this.state.isLogisticOrderHistoryFormOpen &&
          !this.state.isLogisticOrderImageFormOpen &&
          this.state.isLogisticOrderDocumentFormOpen &&
          this.getDocumentView()}
        {this.state.isLogisticOrderListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <LogisticOrderListForm
              {...this.state}
              editLogisticOrder={this.editLogisticOrder}
              filterLogisticOrder={this.filterLogisticOrder}
              resetLogisticOrder={this.resetLogisticOrder}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              handleSortingChange={this.handleSortingChange}
              criteriaOnChange={this.criteriaOnChange}
            />
          )}
        <ReasonCaptureComponent
          reasons={this.state.unapprovalReasons}
          reasonData={this.state.reasonData}
          title="InBound Order UnApprove"
          onChange={this.onUnApproveReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.unApproveReasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.unApproveReasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={
            this.displayAutoCompleteUnApproveReasonList
          }
          showAutoCompleteReasonList={
            this.state.showAutoCompleteUnApproveReasonList
          }
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="InBound Order Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />

        <AddressComponent
          {...this.state}
          isShowPopup={this.state.isShowAddressPopup}
          // addressData={this.state.addressData}
          title={"Address"}
          closeAlertAddressModalCallBack={this.closeAlertAddressModalCallBack}
          onChange={this.addressOnChange}
          onClick={this.addressOnClick}
          // disabled={this.state.disableFormFields}
          // cityList={this.state.cityList}
          onCityChange={this.onCityChange}
          cityEnterKeyEventHandler={this.cityEnterKeyEventHandler}
          displayAutoCompleteCityList={this.displayAutoCompleteCityList}
          onStateChange={this.onStateChange}
          stateEnterKeyEventHandler={this.stateEnterKeyEventHandler}
          displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          onCountryChange={this.onCountryChange}
          countryEnterKeyEventHandler={this.countryEnterKeyEventHandler}
          displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={false}
          isShowPopup={this.state.isShowLinePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl0}
          title={"LINE DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl0}
              hideAlertCallBack={this.hideAlertCallBackLvl0}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.addOrUpdateLine(e)}
                disabled={this.state.isDisabledFields}
              >
                Add/Update
              </Button>

              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.clearLineData(e)}
                disabled={this.state.isDisabledFields}
              >
                Clear
              </Button>
            </div>
          }
          content={
            <LineDetailsEntryPopup
              {...this.state}
              isDisabledFields={this.state.isDisabledFields}
              is3PL={this.state.is3PL}
              isAllowManualAdjustment={this.state.isAllowManualAdjustment}
              isShowAdjQtyButton={this.state.isShowAdjQtyButton}
              logisticOrderData={this.state.logisticOrderData}
              logisticOrderLineData={this.state.logisticOrderLineData}
              onLineChange={this.onLineChange}
              onFabricCodeChange={this.onFabricCodeChange}
              fabricCodeEnterKeyEventHandler={
                this.fabricCodeEnterKeyEventHandler
              }
              fabricPageListForAutoCompleteList={
                this.state.fabricPageListForAutoCompleteList
              }
              showAutoCompleteFabricList={this.state.showAutoCompleteFabricList}
              displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
              onFabricColourCodeChange={this.onFabricColourCodeChange}
              fabricColourEnterKeyEventHandler={
                this.fabricColourEnterKeyEventHandler
              }
              displayAutoCompleteColourList={this.displayAutoCompleteColourList}
              colorLookupHandler={this.state.colorLookupHandler}
              fabricColourPageListForAutoCompleteList={
                this.state.fabricColourPageListForAutoCompleteList
              }
              showAutoCompleteColourList={this.state.showAutoCompleteColourList}
              // isModify={this.isModify}
              isShowColorLookup={this.state.isShowColorLookup}
              lnkFabricModule={this.lnkFabricModule}
              adjustedQuantityHandler={this.adjustedQuantityHandler}
              isShowUomLookup={this.state.isShowUomLookup}
              uomLookupHandler={this.state.uomLookupHandler}
              showAutoCompleteUOMList={this.state.showAutoCompleteUOMList}
              uomPageListForAutoCompleteList={
                this.state.uomPageListForAutoCompleteList
              }
              onUOMCodeChange={this.onUOMCodeChange}
              uomEnterKeyEvent={this.uomEnterKeyEvent}
              displayAutoCompleteUomList={this.displayAutoCompleteUomList}
              openItemInvPositionInq={this.openItemInvPositionInq}
              openItemCurrentInvInq={this.openItemCurrentInvInq}
              openItemPurchaseHistoryInq={this.openItemPurchaseHistoryInq}
              getLogisticLineImagePathMain={this.getLogisticLineImagePathMain}
              getLogisticLineImagePathWeb={this.getLogisticLineImagePathWeb}
              getLogisticLineImagePathFront={this.getLogisticLineImagePathFront}
              getLogisticLineImagePathBack={this.getLogisticLineImagePathBack}
            />
          }
        />

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.state.isShowAdjustedQuantityPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBackLvl1}
          title={"PurchaseOrderLine Adjustment Details"}
          closeOnDocumentClick={false}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlertLvl1}
              hideAlertCallBack={this.state.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={(e) => this.adjContinueHandler(e)}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <AdjustedQuantityDetail
              {...this.state}
              onAdjustmentChange={this.onAdjustmentChange}
              displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
              reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
              onAdjustmentReasonChange={this.onAdjustmentReasonChange}
              addOrUpdateAdj={this.addOrUpdateAdj}
              adjLineHandler={this.adjLineHandler}
              deleteAdjustmentLine={this.deleteAdjustmentLine}
              clearAdjLines={this.clearAdjLines}
            />
          }
        />
      </div>
    );
  }
}
class AdjustedQuantityDetail extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //   purchaseOrderData: new PurchaseOrderBean(),
      //   purchaseOrderLineData: new PurchaseOrderLineBean(),
      //   isShowElements: false,
      //   isShowPopup: false,
      //   inquiryDataList: [],
      //   criteria: new InventorySalesPurchasePositionCriteriaBean(),
      //   error_list: [],
      //   pageList: new PageListBean(),
      //   isShowPDFButton: false,
      //   isShowExcelButton: false,
      //   purchaseAdjustmentReasons: [],
      adjReasonLookupHandler: null,
    };
    this.reasonCodeRef = React.createRef();
  }
  componentDidMount() {
    if (this.reasonCodeRef.current != null) {
      this.reasonCodeRef.current.focus();
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let adjReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.adjReasons,
      "Adjustment Reason"
    );
    this.setState({ adjReasonLookupHandler: adjReasonLookupHandler });
  };

  render() {
    const logisticOrderLineData = this.props.logisticOrderLineData;
    const is3PL = this.props.is3PL;
    const adjLines = this.props.adjLines;
    const adjustmentData = this.props.adjustmentData;

    // let purchaseOrderLineDatas = this.props.purchaseOrderLineDatas;
    // let purchaseOrderLineAdjustmentDataList =
    //   this.props.purchaseOrderLineAdjustmentDataList;
    // let purchaseOrderLineAdjustmentData =
    //   this.props.purchaseOrderLineAdjustmentData;
    // purchaseOrderLineAdjustmentData.uomCode = purchaseOrderLineDatas.uomCode;
    // purchaseOrderLineAdjustmentData.lineNumber =
    //   purchaseOrderLineDatas.lineNumber;
    // purchaseOrderLineAdjustmentData.companyCode = this.companyCode;
    const textAreaStyle = {
      maxHeight: "3em",
      minHeight: "2em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.companyCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>InBound Order#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.logisticOrderNumber}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Ln#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.lineNumber}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.inventoryUomCode}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          {is3PL ? (
            <Col sm="1">
              <FormLabel>Item</FormLabel>
            </Col>
          ) : (
            <Col sm="1">
              <FormLabel>FabricStyleCode</FormLabel>
            </Col>
          )}
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.fabricStyleCode}
              disabled={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              value={logisticOrderLineData.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.colorCode}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>SKU</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.skuNumber}
              disabled={true}
            />
          </Col>
        </Row>
        <div className="div_Custom_3">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Ln#</th>
                <th>Reason</th>
                <th>AdjustedQty</th>
                <th>AdjustedUOM</th>
                <th>Delete</th>
              </tr>
            </thead>
            {adjLines != null && (
              <tbody>
                {adjLines.map((ln, i) => (
                  <tr key={i} data-item={ln}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.props.adjLineHandler(e, ln)}
                      >
                        {ln.adjustmentLineNumber}
                      </Button>
                    </td>
                    <td>{ln.code}</td>
                    <td>{ln.adjustedQuantity}</td>
                    <td>{ln.uomCode}</td>
                    <td>
                      {!ln.isFetched && (
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={(e) =>
                            this.props.deleteAdjustmentLine(e, ln)
                          }
                        >
                          <DeleteIcon />
                        </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </div>
        <Row>
          <Col sm="1">
            <FormLabel>Ln#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={adjustmentData.adjustmentLineNumber}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Reason Code</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.reasonCodeRef}
              name="code"
              onChange={this.props.onAdjustmentReasonChange}
              value={adjustmentData.code}
              placeholder="Reason"
              lookupRequired={true}
              lookupHandler={this.state.adjReasonLookupHandler}
              disabled={false}
              enterKeyEventHandler={this.props.reasonEnterKeyEventHandler}
              autoCompleteListData={
                this.props.reasonPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.props.displayAutoCompleteReasonList}
              showAutoCompleteList={this.props.showAutoCompleteReasonList}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Adj Qty</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="adjustedQuantity"
              onChange={this.props.onAdjustmentChange}
              value={adjustmentData.adjustedQuantity}
              // disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"uomCode"}
              onChange={this.props.onAdjustmentChange}
              value={adjustmentData.uomCode}
              // disabled={isDisabledFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Description</FormLabel>
          </Col>
          <Col sm="7">
            <textarea
              style={textAreaStyle}
              className="form-control"
              name="description"
              type="text"
              onChange={this.props.onAdjustmentChange}
              value={adjustmentData.description}
            // disabled={isDisabledFields}
            />
          </Col>
          <Col sm="2">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              onClick={(e) => this.props.addOrUpdateAdj(e)}
            >
              Add/Update
            </Button>
          </Col>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.props.clearAdjLines(e)}
            >
              Clear{" "}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}
class LogisticOrderListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() { }

  criteriaOnChange = (e) => {
    this.props.criteriaOnChange(e);
  };
  editLogisticOrder = (e, val) => {
    if (e.detail === 1) this.props.editLogisticOrder(val);
  };
  filterLogisticOrder = (e) => {
    if (e.detail === 1) this.props.filterLogisticOrder();
  };
  resetLogisticOrder = (e) => {
    if (e.detail === 1) this.props.resetLogisticOrder();
  };
  loadFirst = (e) => {
    if (e.detail === 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail === 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail === 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail === 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == KeyConstants.ENTER_KEY) {
      this.props.filterLogisticOrder(e);
    }
  };
  render() {
    const criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let isLoading = this.props.isLoading;
    const logisticOrder_list = this.props.logisticOrder_list;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.criteriaOnChange}
                name="orderStatus"
                value={criteria.orderStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"R"}>Received</option>
                <option value={"I"}>Partially Received</option>
                <option value={"H"}>Force Close</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                placeholder="Enter Value to Filter.."
                onChange={this.criteriaOnChange}
                onKeyDown={this.onKeyDown}
                value={criteria.searchName}
                name="searchName"
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterLogisticOrder(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetLogisticOrder(e)}
              >
                Reset
              </Button>
            </div>
            <div className=""> </div>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  InBound Order
                  {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerCode")}
                >
                  customer
                  {this.props.order === "desc" &&
                    this.props.sortField === "customerCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerName")}
                >
                  customer Name
                  {this.props.order === "desc" &&
                    this.props.sortField === "customerName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "orderDate")}>
                  Created Date
                  {this.props.order === "desc" &&
                    this.props.sortField === "orderDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "containerNumber")
                  }
                >
                  Container
                  {this.props.order === "desc" &&
                    this.props.sortField === "containerNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerReferenceNumber")
                  }
                >
                  Reference#
                  {this.props.order === "desc" &&
                    this.props.sortField === "customerReferenceNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "orderStatus")}>
                  Status
                  {this.props.order === "desc" &&
                    this.props.sortField === "orderStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>

            <tbody>
              {logisticOrder_list.map((ln, i) => (
                <tr key={i}>
                  <td>
                    <Button
                      size="sm"
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.editLogisticOrder(e, ln.code)}
                    >
                      {ln.code}
                    </Button>
                  </td>
                  <td>{ln.customerCode}</td>
                  <td>{ln.customerName}</td>
                  <td>{ModuleUtils.getDateFormat_v1(ln.orderDate)}</td>
                  <td>{ln.containerNumber}</td>
                  <td>{ln.customerReferenceNumber}</td>
                  <td>
                    {ModuleUtils.getLogisticOrderStatusCaption(ln.orderStatus)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

class LogisticOrderEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
      customerLookupHandler: null,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    //
  };
  initLookupHandlers = () => {
    //
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  getLogisticLine = (e, rowData) => {
    if (e.detail === 1) {
      this.props.getFabricInages(rowData.fabricStyleCode);
      this.props.getLogisticLine(rowData);
    }
  };
  cancelLogisticOrderLine = (e, rowData) => {
    if (e.detail === 1) this.props.cancelLogisticOrderLine(rowData);
  };

  render() {
    const logisticOrderData = this.props.logisticOrderData;
    let lines = new Array();
    if (!isEmptyArray(logisticOrderData.lines)) lines = logisticOrderData.lines;
    return (
      <div>
        <Row>
          <Col sm="1">
            <FormLabel>Date</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="orderDate"
              onChange={this.onChange}
              value={logisticOrderData.orderDate}
              // isMandatory={true}
              //Og  disabled={true}
              disabled={this.props.disableUpdatableFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Customer</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              onChange={this.props.customerOnChange}
              name="customerCode"
              placeholder="Customer"
              value={logisticOrderData.customerCode}
              lookupRequired={true}
              lookupHandler={this.state.customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.props.customerEnterKeyEventHandler}
              autoCompleteListData={
                this.props.customerPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCustomerCompleteList
              }
              showAutoCompleteList={this.props.isShowAutoCompleteCustomerList}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>

          <Col sm="3">
            <InputTextbox
              name="customerName"
              type="text"
              onChange={this.props.customerOnChange}
              readOnly={true}
              value={logisticOrderData.customerName}
            />
          </Col>

          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>Location</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.props.onLocationChange}
              name="locationCode"
              placeholder="locationCode"
              value={logisticOrderData.locationCode}
              lookupRequired={true}
              lookupHandler={this.state.warehouseLookupHandler}
              enterKeyEventHandler={this.props.locationEnterKeyEventHandler}
              autoCompleteListData={
                this.props.locationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.props.displayAutoCompleteLocationList
              }
              showAutoCompleteList={this.props.isShowAutoCompleteLocationList}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            ></InputTextbox>
          </Col>
        </Row>
        <Row>
          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>Ref</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="customerReferenceNumber"
              placeholder="ReferenceNumber"
              value={logisticOrderData.customerReferenceNumber}
              disabled={this.props.disableUpdatableFields}
            ></InputTextbox>
          </Col>
          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>Container</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onChange}
              name="containerNumber"
              placeholder="containerNumber"
              value={logisticOrderData.containerNumber}
              disabled={this.props.disableUpdatableFields}
            ></InputTextbox>
          </Col>
          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>WareHouse Po </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="warehousePurchaseOrderNumber"
              onChange={this.onChange}
              value={logisticOrderData.warehousePurchaseOrderNumber}
              disabled={this.props.disableUpdatableFields}
            />{" "}
          </Col>
          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>ProjectNumber </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="projectNumber"
              onChange={this.onChange}
              value={logisticOrderData.projectNumber}
              disabled={this.props.disableUpdatableFields}
            />{" "}
          </Col>
          </Row>
          <Row>
          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>Total Qty</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              onChange={this.onChange}
              name="logisticOrderTotalQuantity"
              value={logisticOrderData.logisticOrderTotalQuantity}
              disabled={true}
              decimalScale={2}
              className="qty_input text-right summary_input"
            />
          </Col>
        {/* </Row>
        <Row> */}
          <Col className="align-items-left" sm="1">
            <FormLabel>Total no.of pallets</FormLabel>
          </Col>

          <Col sm="2">
            <NumberFormatInputbox
              value={logisticOrderData.totalNumberOfPallets}
              onChange={this.onChange}
              // className="text-right"
              decimalScale={0}
              name={"totalNumberOfPallets"}
              // disabled={this.props.isDisabledFields}
              className="qty_input text-right summary_input"
              disabled={true}
            />
          </Col>

          <Col className="align-items-left" sm="1">
            <FormLabel>Expected Received Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name="expectedReceivedDate"
              value={logisticOrderData.expectedReceivedDate}
              onChange={this.onChange}
              disabled={this.props.disableUpdatableFields}
            />
          </Col>
          <Col className="align-fabricStyles-left" sm="1">
            <FormLabel>Expected Received Time</FormLabel>
          </Col>
          <Col sm="2">
            {/* <InputTextbox
              onChange={this.onChange}
              name="expectedReceivedTime"
              value={logisticOrderData.expectedReceivedTime}
              disabled={this.props.isDisabledFields}
            ></InputTextbox> */}
            <TimePickerComponent
              onChange={this.onChange}
              name="expectedReceivedTime"
              value={logisticOrderData.expectedReceivedTime}
              disabled={this.props.disableUpdatableFields}
              enterKeyEventHandler={this.props.getCurrentTime}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel
              className="hyperlinklabel"
              onClick={(e) => this.props.addressClickHandler(e)}
              disabled={this.props.isDisabledFields}
            >
              Address
            </FormLabel>
          </Col>
          <Col sm="1">
            <Button
              className="hyperLinkText"
              variant="secondry"
              onClick={(e) => this.props.openDocPopup(e)}
            >
              Documents
            </Button>
          </Col>
          <Col sm="1">
            <Button
              className="hyperLinkText"
              variant="secondry"
              onClick={(e) => this.props.openImagePopup(e)}
            >
              Images
            </Button>
          </Col>

          <Col sm="4">
            <Images
              logisticOrderData={this.props.logisticOrderData}
              mainImageUrl={this.props.mainImageUrl}
              webImageUrl={this.props.webImageUrl}
              frontImageUrl={this.props.frontImageUrl}
              backImageUrl={this.props.backImageUrl}
              openItemImage={this.props.openItemImage}
            />
          </Col>
        </Row>
        {/* <TimePickerComponent />{" "} */}
        <Row>
          <Col className="align-items-left">
            <FormLabel>INBOUND ORDER LINES</FormLabel>{" "}
          </Col>
        </Row>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th></th>
                <th>
                  <Button
                    size="sm"
                    onClick={(e) => this.props.openLogisticLineForm(e)}
                    // disabled={}
                    id="fabric_Add_Button"
                    className="enterFocus"
                  >
                    <AddIcon />
                  </Button>
                </th>
                <th>Item</th>
                <th>Item Name</th>
                <th>Color</th>
                <th>Rcd Qty</th>
                <th>Open Qty</th>
                <th>Inventory UOM</th>
                <th>UOM</th>
                <th>Order Qty</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {lines.map((ln, index) => (
                <tr key={index}>
                  <td>
                    <ShortCutMenuPopup
                      value={ln.fabricStyleCode}
                      // popupData = {this.state.tempPopUpData } 
                      menuItems={
                        <ul >
                          {/* <li
                           className="shortcut-menu-item"
                           onClick={(e) => this.props.lnkFabricModule(e, ln.fabricStyleCode)}
                          >
                            Item Info
                          </li> */}
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.props.lnkFabricModuleV1(
                                e,
                                ln.fabricStyleCode
                              )
                            }
                          >
                           {" "}
                           Item Info{" "}
                          </li>


                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.props.openItemPurchaseHistoryInq(e, ln.fabricStyleCode)
                            }
                          >
                             {" "}
                             Vendor-Item Purchase History{""}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.props.openItemCurrentInvInq(e, ln.fabricStyleCode)
                            }
                          >
                            {" "}
                            Item Current Inventory Level{""}
                          </li>

                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.props.openItemInvPositionInq(e, ln.fabricStyleCode)
                            }
                          >
                           {" "}
                           Item Inventory Position{""}
                          </li>

                        
                        </ul>
                      } />
                  </td>
                  <td>
                    {" "}
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.getLogisticLine(e, ln)}
                    >
                      {ln.lineNumber}
                    </Button>
                  </td>
                  <td>{ln.fabricStyleCode}</td>
                  <td>{ln.fabricStyleName}</td>
                  <td>{ln.colorCode}</td>
                  <td className="text-right">{ln.receivedQuantity}</td>
                  <td className="text-right">{ln.openQuantity}</td>
                  <td>{ln.inventoryUomCode}</td>
                  <td>{ln.uomCode}</td>
                  <td className="text-right">{ln.orderQuantity}</td>
                  <td>
                    {ModuleUtils.getLogisticOrderLineStatusCaption(
                      ln.lineStatus
                    )}
                  </td>
                  <td>
                    <Button
                      disabled={ln.isFetched}
                      onClick={(e) => this.cancelLogisticOrderLine(e, ln)}
                    >
                      <DeleteIcon />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {lines.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.props.isShowLinePopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.props.closeAlertModalCallBackLvl0}
          title={"LINE DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlertLvl0}
              hideAlertCallBack={this.props.hideAlertCallBackLvl0}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                onClick={this.props.addOrUpdateLine}
                disabled={this.props.isDisabledFields}
              >
                Add/Update
              </Button>

              <Button
                className="header_buttons"
                size="sm"
                onClick={this.props.clearLineData}
                disabled={this.props.isDisabledFields}
              >
                Clear
              </Button>
            </div>
          }
          content={
            <LineDetailsEntryPopup
              isDisabledFields={this.props.isDisabledFields}
              is3PL={this.props.is3PL}
              isAllowManualAdjustment={this.props.isAllowManualAdjustment}
              isShowAdjQtyButton={this.props.isShowAdjQtyButton}
              logisticOrderData={this.props.logisticOrderData}
              logisticOrderLineData={this.props.logisticOrderLineData}
              onLineChange={this.props.onLineChange}
              onFabricCodeChange={this.props.onFabricCodeChange}
              fabricCodeEnterKeyEventHandler={
                this.props.fabricCodeEnterKeyEventHandler
              }
              fabricPageListForAutoCompleteList={
                this.props.fabricPageListForAutoCompleteList
              }
              showAutoCompleteFabricList={this.props.showAutoCompleteFabricList}
              displayAutoCompleteFabricList={
                this.props.displayAutoCompleteFabricList
              }
              onFabricColourCodeChange={this.props.onFabricColourCodeChange}
              fabricColourEnterKeyEventHandler={
                this.props.fabricColourEnterKeyEventHandler
              }
              displayAutoCompleteColourList={
                this.props.displayAutoCompleteColourList
              }
              colorLookupHandler={this.props.colorLookupHandler}
              fabricColourPageListForAutoCompleteList={
                this.props.fabricColourPageListForAutoCompleteList
              }
              showAutoCompleteColourList={this.props.showAutoCompleteColourList}
              // isModify={this.isModify}
              isShowColorLookup={this.props.isShowColorLookup}
              lnkFabricModule={this.props.lnkFabricModule}
              adjustedQuantityHandler={this.props.adjustedQuantityHandler}
              isShowUomLookup={this.props.isShowUomLookup}
              uomLookupHandler={this.props.uomLookupHandler}
              showAutoCompleteUOMList={this.props.showAutoCompleteUOMList}
              uomPageListForAutoCompleteList={
                this.props.uomPageListForAutoCompleteList
              }
              onUOMCodeChange={this.props.onUOMCodeChange}
              uomEnterKeyEvent={this.props.uomEnterKeyEvent}
              displayAutoCompleteUomList={this.props.displayAutoCompleteUomList}
              openItemInvPositionInq={this.props.openItemInvPositionInq}
              openItemCurrentInvInq={this.props.openItemCurrentInvInq}
              openItemPurchaseHistoryInq={this.props.openItemPurchaseHistoryInq}
            />
          }
        /> */}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={false}
          isShowPopup={this.props.isShowItemImagePopup}
          closeAlertModalCallBack={this.props.closeAlertModalCallBackLvl1}
          title={"Item Images"}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlertLvl1}
              hideAlertCallBack={this.props.hideAlertCallBackLvl1}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              {/* {isDisableaddOrUpdate ? null : (
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.props.addorUpdateImageData(e)}
                  disabled={isDisabledFields}
                >
                  Add/Update
                </Button>
              )} */}
            </div>
          }
          content={<ItemImagePopup {...this.props} />}
        />
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel5"}
          isModulePopup={false}
          isShowPopup={this.props.isShowItemDocPopup}
          closeAlertModalCallBack={this.props.closeAlertModalCallBackLvl5}
          title={"Item Documents"}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.props.alertMessage}
              alertErrorType={this.props.alertType}
              isShowAlert={this.props.isShowAlertLvl5}
              hideAlertCallBack={this.props.hideAlertCallBackLvl5}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              {/* <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.props.addorUpdateDocData(e)}
                disabled={isDisabledFields}
              >
                Add/Update
              </Button> */}
            </div>
          }
          content={<ItemDocPopup {...this.props} />}
        />
      </div>
    );
  }
}
class LineDetailsEntryPopup extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricStyleRef = React.createRef();
    this.colorCodeRef = React.createRef();
    this.state = {
      // isShowFabricModule: false,
      // isShowItemInventoryPositionInq: false,
      // isShowItemCurrentInventoryInq: false,
      // isShowFabricPurchaseHistoryInq: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.setFocus();
    this.initLookupHandlers();
  }

  initLookupHandlers = () => {
    const logisticOrderData = { ...this.props.logisticOrderData };
    // let fabricLookupHandler = new FabricStyleLookupHandler(
    //   this.companyCode,
    //   "Item"
    // );
    // this.setState({ fabricLookupHandler: fabricLookupHandler });

    if (this.props.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
        logisticOrderData.customerCode
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    } else {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Fabric"
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }
  };

  setFocus = () => {
    if (
      this.fabricStyleRef.current != null &&
      this.fabricStyleRef.current != undefined
    ) {
      setTimeout(() => {
        this.fabricStyleRef.current.focus();
      }, 100);
    }
  };

  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onFabricCodeChange = (e) => {
    this.props.onFabricCodeChange(e);
  };
  fabricCodeEnterKeyEventHandler = (e) => {
    this.props.fabricCodeEnterKeyEventHandler(e);
    if (this.colorCodeRef.current != null) {
      this.colorCodeRef.current.focus();
    }
  };
  onFabricColourCodeChange = (e) => {
    this.props.onFabricColourCodeChange(e);
  };
  fabricColourEnterKeyEventHandler = (e) => {
    this.props.fabricColourEnterKeyEventHandler(e);
  };

  displayAutoCompleteColourList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteColourList(showAutoCompleteList);
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteFabricList(showAutoCompleteList);
  };

  adjustedQuantity = () => {
    this.props.adjustedQuantity();
  };

  // closeModalCallBack = (isOpen) => {
  //   this.setState({
  //     isShowFabricModule: isOpen,
  //     isShowItemInventoryPositionInq: isOpen,
  //     isShowItemCurrentInventoryInq: isOpen,
  //     isShowFabricPurchaseHistoryInq: isOpen,

  //     moduleForPopup: [],
  //   });
  // };

  // onPopupModalExit = () => {
  //   this.closeModalCallBack(false);
  // };
  // lnkFabricModule = () => {
  //   let logisticOrderLineData = this.props.logisticOrderLineData;
  //   let code = logisticOrderLineData.fabricStyleCode;
  //   if (code !== "" && code !== undefined) {
  //     this.setState({
  //       isShowFabricModule: true,
  //       moduleForPopup: (
  //         <PopupFabricModule
  //           fabricStyleCode={code}
  //           onModuleExit={this.onPopupModalExit}
  //         />
  //       ),
  //     });
  //   }
  // };
  // openItemPurchaseHistoryInq = (code) => {
  //   if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
  //     this.setState({
  //       isShowFabricPurchaseHistoryInq: true,
  //       moduleForPopup: (
  //         <PopupFabricPurchaseHistoryInq
  //           fabricCode={code}
  //           // vendorCode={vendorCode}
  //           onModuleExit={this.onPopupModalExit}
  //         />
  //       ),
  //     });
  //   }
  // };

  // openItemInvPositionInq = (code) => {
  //   if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
  //     this.setState({
  //       isShowItemInventoryPositionInq: true,
  //       moduleForPopup: (
  //         <PopupFabricInventoryPositionInq
  //           code={code}
  //           onModuleExit={this.onPopupModalExit}
  //         />
  //       ),
  //     });
  //   }
  // };

  // openItemCurrentInvInq = (code) => {
  //   if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
  //     this.setState({
  //       isShowItemCurrentInventoryInq: true,
  //       moduleForPopup: (
  //         <PopupItemCurrentInventoryInq
  //           code={code}
  //           onModuleExit={this.onPopupModalExit}
  //         />
  //       ),
  //     });
  //   }
  // };
  render() {
    const logisticOrderLineData = this.props.logisticOrderLineData;
    const logisticOrderData = this.props.logisticOrderData;
    const fabricStyleData = this.props.fabricStyleData;
    return (
      <div>
        {/* <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricPurchaseHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemInventoryPositionInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowItemCurrentInventoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
          lockScroll={true}
        ></MultiViewPopup> */}
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              value={logisticOrderData.companyCode}
              disabled={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Order#</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={logisticOrderData.code} disabled={true} />
          </Col>

          <Col sm="1">
            <FormLabel>Customer#</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              value={logisticOrderData.customerCode}
              disabled={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              value={logisticOrderData.customerName}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Line#</FormLabel>
          </Col>

          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.lineNumber}
              disabled={true}
            />
          </Col>

          <Col className="so-align-items-left" sm="1">
            <FormLabel
              className="hyperlinklabel"
              onClick={(e) => this.props.lnkFabricModule(e)}
            >
              Item
            </FormLabel>
            <Col>
              <ShortCutMenuPopup
                value={logisticOrderLineData.fabricStyleCode}
                menuItems={
                  <ul>
                    <li
                      className="shortcut-menu-item"
                      onClick={(e) => this.props.lnkFabricModule(e)}
                    >
                      {" "}
                      Item Info{" "}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      onClick={(e) =>
                        this.props.openItemPurchaseHistoryInq(
                          e,
                          logisticOrderLineData.fabricStyleCode
                        )
                      }
                    >
                      {" "}
                      Vendor-Item Purchase History{""}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      onClick={(e) =>
                        this.props.openItemCurrentInvInq(
                          e,
                          logisticOrderLineData.fabricStyleCode
                        )
                      }
                    >
                      {" "}
                      Item Current Inventory Level{""}
                    </li>
                    <li
                      className="shortcut-menu-item"
                      onClick={(e) =>
                        this.props.openItemInvPositionInq(
                          e,
                          logisticOrderLineData.fabricStyleCode
                        )
                      }
                    >
                      {" "}
                      Item Inventory Position{""}
                    </li>
                  </ul>
                }
              />
            </Col>
          </Col>

          <Col sm="2">
            <InputTextbox
              ref={this.fabricStyleRef}
              name="fabricStyleCode"
              onChange={this.onFabricCodeChange}
              disabled={this.props.isDisabledFields}
              value={logisticOrderLineData.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.fabricCodeEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.props.showAutoCompleteFabricList}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              type="text"
              value={logisticOrderLineData.fabricStyleName}
              onChange={this.onLineChange}
              readOnly={true}
              disabled={true}
            />
          </Col>
          {/* <Col sm="2">
            <FormLabel>Width</FormLabel>
          </Col> */}
          {/* <Col sm="4">
            <InputTextbox
              name="widthCode"
              type="text"
              placeholder="Enter widthCode"
              value={logisticOrderLineData.widthCode}
              onChange={this.onLineChange}
              disabled={true}
            />
          </Col> */}
          <Col className="align-items-left" sm="1">
            <FormLabel>Number of Pallets</FormLabel>
          </Col>

          <Col sm="2">
            <NumberFormatInputbox
              value={logisticOrderLineData.numberOfPallets}
              onChange={this.onLineChange}
              // className="text-right"
              decimalScale={0}
              name={"numberOfPallets"}
              disabled={this.props.isDisabledFields}
              className="qty_input text-right summary_input"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="colorCode"
              type="text"
              placeholder={this.props.isShowColorLookup ? "Enter Color" : ""}
              value={logisticOrderLineData.colorCode}
              onChange={this.onFabricColourCodeChange}
              lookupRequired={this.props.isShowColorLookup}
              lookupHandler={this.props.colorLookupHandler}
              enterKeyEventHandler={this.fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                this.props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteColourList}
              showAutoCompleteList={this.props.showAutoCompleteColourList}
              isMandatory={this.props.isShowColorLookup}
              disabled={this.props.isDisabledFields}
              readOnly={!this.props.isShowColorLookup}
            />
          </Col>

          <Col sm="1">
            <FormLabel>UOM</FormLabel>
          </Col>
          <Col sm="2">
            {/* <InputTextbox
              name="uomCode"
              type="text"
              value={logisticOrderLineData.uomCode}
              onChange={this.onLineChange}
              disabled={true}
            /> */}
            <InputTextbox
              onChange={this.props.onUOMCodeChange}
              name="uomCode"
              value={logisticOrderLineData.uomCode}
              lookupRequired={this.props.isShowUomLookup}
              lookupHandler={this.props.uomLookupHandler}
              enterKeyEventHandler={this.props.uomEnterKeyEvent}
              autoCompleteListData={this.props.uomPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.props.displayAutoCompleteUomList}
              showAutoCompleteList={this.props.showAutoCompleteUOMList}
              disabled={
                !this.props.isShowUomLookup
                //  && this.props.isDisabledFields
              }
              isMandatory={this.props.isShowUomLookup}
            ></InputTextbox>
          </Col>

          <Col sm="1">
            <FormLabel>Inventory UOM</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              value={logisticOrderLineData.inventoryUomCode}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>ConversionRate</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"uomConversionRate"}
              onChange={this.onLineChange}
              value={logisticOrderLineData.uomConversionRate}
              className="text-right"
              decimalScale={2}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Qty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"orderQuantity"}
              onChange={this.onLineChange}
              value={logisticOrderLineData.orderQuantity}
              className="text-right"
              decimalScale={2}
              // isModifyView={isModify}
              disabled={this.props.isDisabledFields}
              isMandatory={true}
            />
          </Col>
          <Col className="so-align-items-left" sm="1">
            <FormLabel>Adj Qty</FormLabel>
            {this.props.isAllowManualAdjustment ? (
              <Col>
                <ShortCutMenuPopup
                  value={logisticOrderData.code}
                  menuItems={
                    <ul>
                      <li
                        className="shortcut-menu-item"
                        onClick={(e) => this.props.adjustedQuantityHandler(e)}
                        disabled={this.props.isDisabledFields}
                      >
                        Adjusted Quantity
                      </li>
                    </ul>
                  }
                />
              </Col>
            ) : null}
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"adjustedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter adjustedQuantity"
              value={logisticOrderLineData.adjustedQuantity}
              className="text-right"
              decimalScale={2}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Rcd Qty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"receivedQuantity"}
              onChange={this.onLineChange}
              value={logisticOrderLineData.receivedQuantity}
              className="text-right"
              decimalScale={2}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Rcd Adj Qty</FormLabel>
          </Col>
          <Col sm="2">
            <NumberFormatInputbox
              name={"receivedAdjustedQuantity"}
              onChange={this.onLineChange}
              value={logisticOrderLineData.receivedAdjustedQuantity}
              className="text-right"
              decimalScale={2}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent
              name={"orderDate"}
              onChange={this.onLineChange}
              value={logisticOrderData.orderDate}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>LocationCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name={"locationCode"}
              // onChange={this.onLineChange}
              value={logisticOrderData.locationCode}
              disabled={true}
            />
          </Col>
        </Row>
        <div className="div_30_no_overflow">
          <Col className="so-align-items-left">
            <FormLabel>Images</FormLabel>{" "}
          </Col>
          <div className="">
            <Row>
              <Col></Col>
              <Col sm="4">
                <img
                  src={`${this.props.getLogisticLineImagePathMain(
                    fabricStyleData
                  )}&a=${new Date().getTime()}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImage;
                  }}
                  alt="Click to Add"
                  width={90}
                  height={90}
                  mode="fit"
                />{" "}
              </Col>
              <Col sm="4">
                <img
                  src={`${this.props.getLogisticLineImagePathWeb(
                    fabricStyleData
                  )}&a=${new Date().getTime()}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImage;
                  }}
                  alt="Click to Add"
                  width={90}
                  height={90}
                  mode="fit"
                />{" "}
              </Col>
              <Col></Col>
            </Row>
            <Row>
              <Col></Col>
              <Col sm="4">
                <img
                  src={`${this.props.getLogisticLineImagePathFront(
                    fabricStyleData
                  )}&a=${new Date().getTime()}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImage;
                  }}
                  alt="Click to Add"
                  width={90}
                  height={90}
                  mode="fit"
                />{" "}
              </Col>
              <Col sm="4">
                <img
                  src={`${this.props.getLogisticLineImagePathBack(
                    fabricStyleData
                  )}&a=${new Date().getTime()}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImage;
                  }}
                  alt="Click to Add"
                  width={90}
                  height={90}
                  mode="fit"
                />{" "}
              </Col>
              <Col></Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}
class LogisticOrderHistoryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    //
  }
  render() {
    let logisticOrderData = this.props.logisticOrderData;
    let statusTracks = new Array();
    if (!isEmptyArray(logisticOrderData.statusTracks)) {
      statusTracks = logisticOrderData.statusTracks;
    }

    let changeHistoryTracks = new Array();
    if (!isEmptyArray(logisticOrderData.changeHistoryTracks)) {
      changeHistoryTracks = logisticOrderData.changeHistoryTracks;
    }

    return (
      <div className="header_div">
        <div className="div_inline">
          {" "}
          <div class="div_Equal">
            <FormLabel>Status History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>OrderAmount</th>
                <th>Status</th>
                <th>Previous Status</th>
                <th>Done By</th>
                <th>Remarks</th>
              </thead>
              <tbody>
                {statusTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="text-right">{list.createdDate}</td>
                    <td className="text-right">
                      {ModuleUtils.getPurchaseOrderStatusCaption(
                        list.currentStatus
                      )}
                    </td>
                    <td className="text-right">
                      {ModuleUtils.getPurchaseOrderStatusCaption(
                        list.previousStatus
                      )}
                    </td>
                    <td className="text-right">{list.createdBy}</td>
                    <td className="text-right">{list.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {statusTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
          <div class="div_Equal">
            <FormLabel>Changes History</FormLabel>
            <Table id="fabrics_tables_default">
              <thead>
                <th>Date</th>
                <th>Done By</th>
                <th>Changes</th>
              </thead>
              <tbody>
                {changeHistoryTracks.map((list, index) => (
                  <tr key={index}>
                    <td className="text-right">{list.updatedDate}</td>
                    <td className="text-right">{list.updatedby}</td>
                    <td className="text-right">{list.description}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {changeHistoryTracks.length != 0 ? null : (
              <div className="no_Data_small">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export function ItemDocPopup(props) {
  const [doc1, setDoc1] = useState(null);
  const [doc1Name, setDoc1Name] = useState(props.doc1Name);
  const [doc1Url, setDoc1Url] = useState(props.doc1Url);

  const [doc2, setDoc2] = useState(null);
  const [doc2Name, setDoc2Name] = useState(props.doc2Name);
  const [doc2Url, setDoc2Url] = useState(props.doc2Url);

  const [doc3, setDoc3] = useState(null);
  const [doc3Name, setDoc3Name] = useState(props.doc3Name);
  const [doc3Url, setDoc3Url] = useState(props.doc3Url);

  const [doc4, setDoc4] = useState(null);
  const [doc4Name, setDoc4Name] = useState(props.doc4Name);
  const [doc4Url, setDoc4Url] = useState(props.doc4Url);

  useEffect(() => {
    setDoc1Name(props.doc1Name);
  }, [props.doc1Name]);
  useEffect(() => {
    setDoc2Name(props.doc2Name);
  }, [props.doc2Name]);
  useEffect(() => {
    setDoc3Name(props.doc3Name);
  }, [props.doc3Name]);
  useEffect(() => {
    setDoc4Name(props.doc4Name);
  }, [props.doc4Name]);

  useEffect(() => {
    setDoc1Url(props.doc1Url);
  }, [props.doc1Url]);
  useEffect(() => {
    setDoc2Url(props.doc2Url);
  }, [props.doc2Url]);
  useEffect(() => {
    setDoc3Url(props.doc3Url);
  }, [props.doc3Url]);
  useEffect(() => {
    setDoc4Url(props.doc4Url);
  }, [props.doc4Url]);

  const handleSubmit = (e, type) => {
    e.preventDefault();
    // if (e.detail == 1) {
    if (type == 1) {
      if (doc1) {
        props.uploadDoc(doc1, 1);
        props.setDoc1Url(URL.createObjectURL(doc1));
        props.setDoc1Data(doc1);
        props.setDoc1Name(doc1.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    } else if (type == 2) {
      if (doc2) {
        props.uploadDoc(doc2, 2);
        props.setDoc2Url(URL.createObjectURL(doc2));
        props.setDoc2Data(doc2);
        props.setDoc2Name(doc2.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    } else if (type == 3) {
      if (doc3) {
        props.uploadDoc(doc3, 3);
        props.setDoc3Url(URL.createObjectURL(doc3));
        props.setDoc3Data(doc3);
        props.setDoc3Name(doc3.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    } else if (type == 4) {
      if (doc4) {
        props.uploadDoc(doc4, 4);
        props.setDoc4Url(URL.createObjectURL(doc4));
        props.setDoc4Data(doc4);
        props.setDoc4Name(doc4.name);
        props.showToast("Uploaded Sucessfully", 1, 5);
      }
    }

    // }
  };

  const docViewHandler = (e, type) => {
    if (e.detail == 1) {
      if (type == 1) {
        window.open(doc1Url);
      } else if (type == 2) {
        window.open(doc2Url);
      } else if (type == 3) {
        window.open(doc3Url);
      } else if (type == 4) {
        window.open(doc4Url);
      }
    }
  };

  const handleChange = (e, type) => {
    e.preventDefault();
    if (type == 1) {
      setDoc1(e.target.files[0]);
      setDoc1Name(e.target.files[0].name);
      setDoc1Url(URL.createObjectURL(e.target.files[0]));
    } else if (type == 2) {
      setDoc2(e.target.files[0]);
      setDoc2Name(e.target.files[0].name);
      setDoc2Url(URL.createObjectURL(e.target.files[0]));
    } else if (type == 3) {
      setDoc3(e.target.files[0]);
      setDoc3Name(e.target.files[0].name);
      setDoc3Url(URL.createObjectURL(e.target.files[0]));
    } else if (type == 4) {
      setDoc4(e.target.files[0]);
      setDoc4Name(e.target.files[0].name);
      setDoc4Url(URL.createObjectURL(e.target.files[0]));
    }
  };

  const deleteDoc = (e, type) => {
    if (e.detail == 1) {
      if (type == 1) {
        setDoc1(null);
        setDoc1Name("");
        props.deleteDoc(1);
      } else if (type == 2) {
        setDoc2(null);
        setDoc2Name("");
        props.deleteDoc(2);
      } else if (type == 3) {
        setDoc3(null);
        setDoc3Name("");
        props.deleteDoc(3);
      } else if (type == 4) {
        setDoc4(null);
        setDoc4Name("");
        props.deleteDoc(4);
      }
      props.showToast("Document deleted sucessfully", 1, 5);
    }
  };

  return (
    <div>
      <Row>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 1)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 1)}
              >
                {doc1Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc1"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc1"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 1)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc1Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 1)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 2)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 2)}
              >
                {doc2Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc2"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc2"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 2)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc2Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 2)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 3)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 3)}
              >
                {doc3Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc3"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc3"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 3)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc3Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 3)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
        <Col sm="12">
          <form onSubmit={(e) => handleSubmit(e, 4)}>
            <div className="d-flex justify-content-center align-items-center pt-2">
              <FormLabel
                className="hyperlinklabel align-middle"
                onClick={(e) => docViewHandler(e, 4)}
              >
                {doc4Name}
              </FormLabel>
            </div>
            <div className="d-flex justify-content-around align-items-center">
              <div>
                <label
                  for="doc4"
                  className="d-flex justify-content-around align-items-center"
                >
                  <div className="img_label">
                    Attach Document
                    <span className="img_icon">
                      <UploadDocIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="doc4"
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt, image/*"
                    onChange={(e) => handleChange(e, 4)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {!isEmptyString(doc4Name) && (
                <div className="d-flex justify-content-around align-middle align-items-center">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteDoc(e, 4)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </Col>
      </Row>
    </div>
  );
}

export function ItemImagePopup(props) {
  const [file, setFile] = useState(null);
  const [fileWeb, setFileWeb] = useState(null);
  const [fileFront, setFileFront] = useState(null);
  const [fileBack, setFileBack] = useState(null);

  const [previewMainUrl, setPreviewMainUrl] = useState(props.mainImageUrl);
  const [previewWebUrl, setPreviewWebUrl] = useState(props.webImageUrl);
  const [previewFrontUrl, setPreviewFrontUrl] = useState(props.frontImageUrl);
  const [previewBackUrl, setPreviewBackUrl] = useState(props.backImageUrl);

  const handleChange = (e, imagePart) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    if (e.target.files[0].size <= max_size) {
      if (imagePart === MAIN_IMAGE_PART) {
        setFile(e.target.files[0]);
        setPreviewMainUrl(URL.createObjectURL(e.target.files[0]));
      } else if (imagePart === WEB_IMAGE_PART) {
        setFileWeb(e.target.files[0]);
        setPreviewWebUrl(URL.createObjectURL(e.target.files[0]));
      }
      if (imagePart === FRONT_IMAGE_PART) {
        setFileFront(e.target.files[0]);
        setPreviewFrontUrl(URL.createObjectURL(e.target.files[0]));
      }
      if (imagePart === BACK_IMAGE_PART) {
        setFileBack(e.target.files[0]);
        setPreviewBackUrl(URL.createObjectURL(e.target.files[0]));
      }
    } else {
      props.showToast("image size is greater", 2);
    }
  };

  const handleSubmit = async (e, imagePart) => {
    e.preventDefault();
    if (imagePart === MAIN_IMAGE_PART) {
      if (file != null) {
        props.setMainUrl(URL.createObjectURL(file));
        props.setMainImg(file);
        props.uploadImage(file, MAIN_IMAGE_PART);
        props.showToast("Main image uploaded sucessfully", 1, 1);
      }
    } else if (imagePart === WEB_IMAGE_PART) {
      if (fileWeb != null) {
        props.setWebUrl(URL.createObjectURL(fileWeb));
        props.setWebImg(fileWeb);
        props.uploadImage(fileWeb, WEB_IMAGE_PART);
        props.showToast("Web image uploaded sucessfully", 1, 1);
      }
    } else if (imagePart === FRONT_IMAGE_PART) {
      if (fileFront != null) {
        props.setFrontUrl(URL.createObjectURL(fileFront));
        props.setFrontImg(fileFront);
        props.uploadImage(fileFront, FRONT_IMAGE_PART);
        props.showToast("Front image uploaded sucessfully", 1, 1);
      }
    } else if (imagePart === BACK_IMAGE_PART) {
      if (fileBack != null) {
        props.setBackUrl(URL.createObjectURL(fileBack));
        props.setBackImg(fileBack);
        props.uploadImage(fileBack, BACK_IMAGE_PART);
        props.showToast("Back image uploaded sucessfully", 1, 1);
      }
    }
  };

  const deleteItemImage = (e, imagePart) => {
    if (e.detail == 1) {
      if (imagePart == MAIN_IMAGE_PART) {
        setFile(null);
        setPreviewMainUrl("");
      } else if (imagePart == WEB_IMAGE_PART) {
        setFileWeb(null);
        setPreviewWebUrl("");
      } else if (imagePart == FRONT_IMAGE_PART) {
        setFileFront(null);
        setPreviewFrontUrl("");
      } else if (imagePart == BACK_IMAGE_PART) {
        setFileBack(null);
        setPreviewBackUrl("");
      }

      props.deleteItemImage(imagePart);
      props.showToast("Image Deleted sucessfully", 1, 1);
    }
  };
  return (
    <div className="img-pop">
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, MAIN_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewMainUrl && ( */}
              <img
                className="img_div"
                src={previewMainUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="mainImgData"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="mainImgData"
                    accept="image/*"
                    onChange={(e) => handleChange(e, MAIN_IMAGE_PART)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {!isEmptyString(previewMainUrl) && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, MAIN_IMAGE_PART)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, WEB_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewWebUrl && ( */}
              <img
                className="img_div"
                src={previewWebUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="webImgData"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="webImgData"
                    accept="image/*"
                    onChange={(e) => handleChange(e, WEB_IMAGE_PART)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {previewWebUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </Button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, WEB_IMAGE_PART)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      <div className="div_inline">
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, FRONT_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewFrontUrl && ( */}
              <img
                className="img_div"
                src={previewFrontUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label
                  for="frontImgData"
                  className="d-flex justify-content-around "
                >
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="frontImgData"
                    accept="image/*"
                    onChange={(e) => handleChange(e, FRONT_IMAGE_PART)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {previewFrontUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, FRONT_IMAGE_PART)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="div_Equal_no_overflow">
          <form onSubmit={(e) => handleSubmit(e, BACK_IMAGE_PART)}>
            <div className="d-flex justify-content-around ">
              {/* {previewBackUrl && ( */}
              <img
                className="img_div"
                src={previewBackUrl}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = noImage;
                }}
                width={275}
                height={275}
                mode="fit"
              />
              {/* )} */}
            </div>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="backImg" className="d-flex justify-content-around ">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>
                  <input
                    type="file"
                    className="img-input"
                    id="backImg"
                    accept="image/*"
                    onChange={(e) => handleChange(e, BACK_IMAGE_PART)}
                    disabled={props.isDisabledFields}
                  />
                </label>
              </div>
              {previewBackUrl && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                      disabled={props.isDisabledFields}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteItemImage(e, BACK_IMAGE_PART)}
                      disabled={props.isDisabledFields}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export function Images(props) {
  const openItemImage = () => {
    props.openItemImage();
  };

  const [mainImg, setMainImg] = useState(props.mainImageUrl);
  const [WebImg, setWebImg] = useState(props.webImageUrl);
  const [frontImg, setFrontImg] = useState(props.frontImageUrl);
  const [backImg, setBackImg] = useState(props.backImageUrl);

  useEffect(() => {
    setMainImg(props.mainImageUrl);
  }, [props.mainImageUrl]);

  useEffect(() => {
    setWebImg(props.webImageUrl);
  }, [props.webImageUrl]);

  useEffect(() => {
    setFrontImg(props.frontImageUrl);
  }, [props.frontImageUrl]);

  useEffect(() => {
    setBackImg(props.backImageUrl);
  }, [props.backImageUrl]);

  const content = (url) => {
    return (
      <img
        src={url}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
      // width={800}
      // height={600}
      // mode="fit"
      />
    );
  };
  return (
    <div>
      <img
        // data-tip={props.mainImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={mainImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      // onClick={openItemImage}
      />{" "}
      <img
        // data-tip={props.webImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={WebImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      <img
        // data-tip={props.frontImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={frontImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      <img
        // data-tip={props.backImageUrl}
        // data-for="global"
        // data-event="click focus"
        src={backImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImage;
        }}
        width={100}
        height={100}
        mode="fit"
      />
      {/* <ReactTooltip
        id="global"
        // aria-haspopup="true"
        className="cstm-img-tool-tip"
        // globalEventOff="click"
        getContent={(dataTip) => content(dataTip)}
        // place='bottom'
      ></ReactTooltip> */}
    </div>
  );
}
export function MutilpleImages(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(props.imgUrl);
  const [images, setImages] = useState([...props.images]);
  const [img_Url, setImageUrl] = useState([...props.preview_Url]);
  const [tempIndex, setIndex] = useState(null);
  const [tempImage, setTempImages] = useState([]);
  const [tempImg_Url, setTempImageUrl] = useState([]);
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [isImageMainPreview, setIsImageMainPreview] = useState(false);
  const isShowDocLabel = props.isShowDocLabel;
  const disabledImages = props.isServiceLineDisablesFields;
  const [imgDetails, setTempFile] = useState(null);

  const [hover, setHover] = useState(false);
  const [hoverData, setHoverData] = useState(new LogisticOrderImageBean());
  const [aftUpload, setAftUpload] = useState(false);

  // const invoiceImage = props.logisticOrderData.invoiceImages.length;

  // const imageEntity = props.imageEntity;

  const [imageEntity, setImagesEntity] = useState(new LogisticOrderImageBean());
  useEffect(() => {
    setImagesEntity(imageEntity);
  }, [imageEntity]);
  const handleChange = (e) => {
    let tempImages = e.target.files;
    if (!isEmptyArray(tempImages)) {
      setIsImageMainPreview(true);
    }
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let img_list = [];
    let previewList = [];
    if (!isEmptyArray(images)) {
      img_list = [...images];
    }
    if (!isEmptyArray(img_Url)) {
      previewList = [...img_Url];
    }
    for (let index = 0; index < tempImages.length; index++) {
      let imgUrl = "";
      if (tempImages[index].size <= max_size) {
        img_list.push(tempImages[index]);
        imgUrl = URL.createObjectURL(tempImages[index]);
        previewList.push(imgUrl);
      } else {
        props.showToast("image size is greater", 2);
      }
    }
    setImages(img_list);
    setImageUrl(previewList);
  };
  useEffect(() => {
    setImageUrl(img_Url);
  }, [img_Url]);

  useEffect(() => {
    setImages(images);
  }, [images]);
  useEffect(() => {
    setIsImageMainPreview(isImageMainPreview);
  }, [isImageMainPreview]);

  const handleImageEditChange = (e) => {
    let max_size = ConfigManager.getUploadImageMaxSizeInMB() * 1024 * 1024;
    let images_temp = [];
    let url_temp = [];
    let imgUrl = "";
    if (e.target.files[0].size <= max_size) {
      images_temp = [...images];
      url_temp = [...img_Url];
      setIsImagePreview(true);
      setIsImageMainPreview(false);
      // })
      for (let i = 0; i < images_temp.length; i++) {
        if (i === tempIndex) {
          let file = e.target.files[0];
          setFile(file);
        }
      }
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          imgUrl = URL.createObjectURL(e.target.files[0]);
          url_temp[i] = imgUrl; // Change the value at index 2
        }
      }
    } else {
      props.showToast("image size is greater", 2);
    }
    setPreviewUrl(imgUrl);
    setTempImages(images_temp);
    setTempImageUrl(url_temp);
  };
  useEffect(() => {
    setIsImagePreview(isImagePreview);
  }, [isImagePreview]);
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setMultiImageUrl(img_Url);
    props.setMultiImgData(images);
    props.uploadMutiImage(images);
    props.showToast("Uploaded Sucessfully", 1);
    setIsImageMainPreview(false);
  };
  const handleEditSubmit = (e) => {
    e.preventDefault();
    let tempFile = file;
    for (let i = 0; i < tempImage.length; i++) {
      if (i === tempIndex) {
        tempFile.imageCode = tempImage[i].imageCode;
        tempImage[i] = tempFile;
      }
    }
    props.setMultiImageUrl(tempImg_Url);
    props.setMultiImgData(tempImage);
    props.uploadMutiImage(tempImage);
    setImageUrl(tempImg_Url);
    props.showToast("Uploaded Sucessfully", 1);
    setIndex(null);
    setIsImagePreview(false);
    setPreviewUrl("");
  };

  const deleteImage = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewUrl("");
      // props.deleteImage();
      props.showToast("Image deleted sucessfully", 1);
      setIsImageMainPreview(false);
      setImages(props.images);
      setImageUrl(props.preview_Url);
    }
  };
  const imageview = (e, index, image) => {

    if (!isImageMainPreview) {
      const files = e.target.currentSrc;
      let imgDetails = null;
      const urls = files;
      setPreviewUrl(urls);
      setIndex(index);
      setIsImagePreview(false);
      // for (let i = 0; i < images.length; i++) {
      //   if (i === index) {
      //     imgDetails = images[i];
      //   }
      // }

      for (let i = 0; i < props.logisticOrderData.orderImages.length; i++) {
        if (i === index) {

          imgDetails = props.logisticOrderData.orderImages[i];
        }
      }

      setTempFile(imgDetails);

      const updatedImageEntity = {
        ...imgDetails, // Spread the class instance to convert to plain object
        tags: imgDetails.tags !== "" ? imgDetails.tags : "",
        notesCommunication: imgDetails.notesCommunication || "",
      };
      setImagesEntity(updatedImageEntity);
      //
    }
  };
  const hoverview = (e, index) => {
    setAftUpload(true);

    if (!aftUpload) return; // Prevent hover logic if 'aftUpload' is false
    if (props.logisticOrderData.isFetched) {
      const hoverDetails = props.logisticOrderData.orderImages[index]; // Get the hovered image by index
      if (hoverDetails) {
        setHoverData(hoverDetails); // Set hover data for the hovered image
      } else {
        setHoverData(new LogisticOrderImageBean()); // Fallback to default or empty data
      }
    }
    setHover(true); // Set hover state to true when mouse is over the image
  };
  const deleteUploadedImage = (e) => {
    if (e.detail === 1) {
      let url_temp = [];
      url_temp = [...img_Url];
      for (let i = 0; i < url_temp.length; i++) {
        if (i === tempIndex) {
          url_temp.splice(i, 1); // Change the value at index 2
        }
      }
      setImageUrl(url_temp);
      props.deleteMutipleImage(tempIndex);
      setPreviewUrl("");
      setTempImageUrl(url_temp);
      setIndex(null);
      setIsImagePreview(false);
    }
  };
  const onImageChange = (e) => {
    const updatedImageEntity = {
      ...imageEntity, // Spread the existing properties
      [e.target.name]: e.target.value, // Update the property based on input name
    };
    setImagesEntity(updatedImageEntity);
  };
  const addImageLines = (e) => {
    if (e.detail === 1) {
      props.addImageLines(imageEntity);
      props.showToast("Details Uploaded Sucessfully", 1);
    }
  };
  const clearImageLines = (e) => {
    if (e.detail === 1) {
      //props.clearImageLines(imageEntity)

      const updatedImageEntity = {
        ...imageEntity, // Spread the existing properties
        tags: "", // Reset tags
        notesCommunication: "", // Reset notesCommunication
      };
      setImagesEntity(updatedImageEntity);
      props.clearImageLines(updatedImageEntity);
    }
  };
  return (
    // const textAreaStyle = {
    //   maxHeight: "10px",
    //   width: "30%",
    //   minHeight: "5em",
    //   resize: "none",
    //   padding: "9px",
    //   boxSizing: "border-box",
    //   fontSize: "15px",
    // };

    <div className="header_div  div_default">
      <div className="div_inline">
        <div className="div_30_no_overflow">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-around ">
              <div>
                <label for="imgTag" className="d-flex justify-content-around">
                  <div className="img_label">
                    Attach Image
                    <span className="img_icon">
                      <CameraIcon />
                    </span>
                  </div>

                  <input
                    type="file"
                    className="img-input"
                    id="imgTag"
                    multiple
                    accept="image/*"
                    onChange={handleChange}
                    disabled={disabledImages}
                  />
                </label>
              </div>
              {isImageMainPreview && (
                <div className="d-flex justify-content-around align-middle">
                  <div className="align-middle-icon">
                    <button
                      id="fabric_Add_Button"
                      type="submit"
                    //  disabled={isShowDocLabel}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="align-middle">
                    <Button
                      id="fabric_Add_Button"
                      onClick={(e) => deleteImage(e)}
                    //   disabled={isShowDocLabel}
                    >
                      <DeleteIcon />
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "0.8rem" }}>
              {!isEmptyArray(img_Url) &&
                img_Url.map((image, index) => (
                  <div key={index} className="column">
                    <div className="effect">
                      <div className="effect-img">
                        <img
                          src={image}
                          alt={`upload-${index}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            border: "1px solid black",
                            marginBottom: "5px", // Space between image and text
                            marginRight: "2px",
                            marginLeft: "2px",
                          }}
                          onClick={(e) => imageview(e, index)}
                          onMouseOver={(e) => hoverview(e, index)}
                          onMouseOut={() => setHover(false)} // Reset hover state on mouse out
                        />
                      </div>
                      {hover == true && (
                        <div className="effect-text">
                          <div class="inner">
                            <p
                            // style={{ fontSize: "12px", margin: 0 }}
                            >
                              {hoverData.imageName}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Index Text Below Image */}
                  </div>
                ))}
            </div>
          </form>
          {/* </div> */}
        </div>
        <div className="div_60_no_overflow">
          {/* <div className="image-preview"> */}

          <form onSubmit={handleEditSubmit}>
            {
              !isEmpty(previewUrl) && (
                <div
                  style={{
                    position: "relative",

                    display: "flex",
                    paddingLeft: "200px",
                  }}
                >
                  <div className="image_grid">
                    {previewUrl != null && (
                      <div
                      // style={{ display: "flex", backgroundColor: "green" }}
                      >
                        <div
                          style={{
                            padding: "10px",
                            width: "100%",
                          }}
                        >
                          <img
                            src={previewUrl}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "200%",
                              float: "left",
                            }}
                          />

                          <label className="d-flex justify-content-around">
                            <div className="d-flex justify-content-around">
                              <span className="img_icon">
                                <CameraIcon />
                              </span>

                              <input
                                type="file"
                                className="img-input"
                                id="imgTag"
                                accept="image/*"
                                onChange={handleImageEditChange}
                                disabled={disabledImages}
                              />

                              <div className="d-flex justify-content-around align-middle">
                                <div className="align-middle">
                                  {isImagePreview && (
                                    <button
                                      id="fabric_Add_Button"
                                      type="submit"
                                      disabled={disabledImages}
                                    >
                                      Upload
                                    </button>
                                  )}
                                </div>
                                <div className="align-middle">
                                  <Button
                                    id="fabric_Add_Button"
                                    onClick={(e) => deleteUploadedImage(e)}
                                    disabled={disabledImages}
                                  >
                                    <DeleteIcon />
                                  </Button>
                                </div>
                              </div>

                              {/* <button
                              type="button"
                              id="fabric_Add_Button"

                            >
                              Remove
                            </button> */}
                            </div>
                          </label>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <Row>
                      <Col sm="2">
                        <FormLabel>Name</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //  value={imageEntity.imageName}
                          value={imageEntity.imageName || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Created By</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          //value={imageEntity.createdBy}
                          value={imageEntity.createdBy || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>created Date</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.createdDate}
                          value={imageEntity.createdDate || ""}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Tags</FormLabel>
                      </Col>
                      <Col sm="9">
                        <InputTextbox
                          // value={imageEntity.tags}
                          value={imageEntity.tags || ""}
                          name="tags"
                          // type="text"
                          onChange={onImageChange}
                          disabled={disabledImages}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="2">
                        <FormLabel>Notes</FormLabel>
                      </Col>
                      <Col sm="9">
                        <textarea
                          style={{
                            maxHeight: "10px",
                            width: "100%",
                            minHeight: "5em",
                            resize: "none",
                            padding: "9px",
                            boxSizing: "border-box",
                            fontSize: "15px",
                          }}
                          // className="form-control"
                          name="notesCommunication"
                          //  type="text"
                          // placeholder="Notes"
                          onChange={onImageChange}
                          value={imageEntity.notesCommunication || ""}
                          // value={imageEntity.notesCommunication}
                          disabled={disabledImages}
                        />
                        {/* <InputTextbox
                                  value={imgDetails.notesCommunication}
                                // disabled={true}
                                /> */}
                      </Col>
                    </Row>

                    <Row>
                      <Col className="text-center">
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          className="header_buttons enterFocus"
                          onClick={(e) => addImageLines(e)}
                          disabled={disabledImages}
                        >
                          Add/Update
                        </Button>
                        <Button
                          id="fabric_Add_Button"
                          size="sm1"
                          onClick={(e) => clearImageLines(e)}
                          disabled={disabledImages}
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>

                    {/* <p>{`Tags        : ${imgDetails.tags}`}</p>
                              <p>{`Notes       : ${imgDetails.notesCommunication}`}</p> */}
                    {/* </Col> */}
                  </div>
                </div>
              )
              // ))
            }
          </form>
          {/* // </div> */}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
export function MutilpleDocuments(props) {
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewDocs] = useState(props.preview_Docs);
  const [documents, setDocuments] = useState([...props.documents]);
  const [tempIndex, setIndex] = useState(null);
  const documentData = props.logisticOrderData.logisticOrderDocuments;
  const [isDocumentUpload, setIsDocumentUpload] = useState(false);

  const disabledImages = props.isServiceLineDisablesFields;
  // useEffect(() => {
  //   setColumns(props.columns);
  // }, [props.columns]);

  const docHandler = (e) => {
    e.preventDefault();
    let tempDocs = e.target.files;
    let doc_list = [];
    let previewList = [];
    if (!isEmptyArray(documents)) {
      doc_list = [...documents];
    }
    if (!isEmptyArray(previewUrl)) {
      previewList = [...previewUrl];
    }
    for (let index = 0; index < tempDocs.length; index++) {
      let docUrl = "";
      doc_list.push(tempDocs[index])
      docUrl = URL.createObjectURL(tempDocs[index])
      previewList.push(docUrl);

    }
    setDocuments(doc_list);
    setPreviewDocs(previewList);
    setIsDocumentUpload(true)
  };

  useEffect(() => {
    setDocuments(documents)
  }, [documents]);

  const handleDocumentSubmit = (e) => {
    e.preventDefault();
    props.uploadMutiDouments(documents);
    props.uploadMutiDoumentsUrl(previewUrl);
    props.showToast("Uploaded Sucessfully", 1);
    setIsDocumentUpload(false)
  };
  const deleteDocs = (e) => {
    if (e.detail == 1) {
      setFile(null);
      setPreviewDocs("");
      props.showToast("Image deleted sucessfully", 1);
      setDocuments(props.documents)
      setIsDocumentUpload(false)
    }
  };


  const deleteDocuments = (e, value, rowData) => {
    let documentDataList = documents;
    let fileUrl = previewUrl;
    documentDataList.map((list, index) => {
      if (list.documentName === rowData.documentName) {
        // list.deleted = true;
        // list.isDeleted = true;
        fileUrl.splice(index, 1);
      }
    });
    setPreviewDocs(fileUrl);
    props.uploadMutiDoumentsUrl(fileUrl);
    props.deleteMultiDocument(rowData);
    // setDocuments(documentDataList);
    // setPreviewDocs(fileUrl);
    // props.uploadMutiDouments(documentDataList);
    // props.uploadMutiDoumentsUrl(fileUrl);
  };
  const editDocument = (e, name, tempIndex) => {
    let docUrl = previewUrl;
    let tempUrl = "";
    if (!isEmptyArray(docUrl)) {
      for (let index = 0; index < docUrl.length; index++) {
        if (index === tempIndex) {
          tempUrl = docUrl[index];
        }
      }
      window.open(tempUrl);
    }
  };
  return (
    <div className="header_div  div_default">
      <div className="div_inline">
        {/* <div className="div_80_no_overflow"> */}
        <div className="div_60_no_overflow">
          <div className="div_Equal_no_overflow">
            <form onSubmit={handleDocumentSubmit}>
              <div className="d-flex justify-content-around ">
                <div>
                  <label for="imgTag" className="d-flex justify-content-around">
                    <div className="img_label">
                      Attach Documents
                      <span className="img_icon">
                        <UploadDocIcon />
                      </span>
                    </div>

                    <input
                      type="file"
                      className="img-input"
                      id="imgTag"
                      multiple
                      accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                      onChange={docHandler}
                      disabled={disabledImages}
                    />
                  </label>
                </div>
                {(isDocumentUpload) && (
                  <div className="d-flex justify-content-around align-middle">
                    <div className="align-middle">
                      <button
                        id="fabric_Add_Button"
                        type="submit"
                      //  disabled={isShowDocLabel}
                      >
                        Upload
                      </button>
                    </div>
                    <div className="align-middle">
                      <Button
                        id="fabric_Add_Button"
                        onClick={(e) => deleteDocs(e)}
                      // disabled={isShowDocLabel}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>


      </div>
      <div className="div_Custom_3">
        <Table id="fabrics_tables_default">
          <thead>
            <tr>
              <th
              // onClick={(e) =>
              //   props.handleSortingStageDocumentChange(e, "documentName")
              // }
              >
                Document
                {/* {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )} */}
              </th>
              <th
              // onClick={(e) =>
              //   props.handleSortingStageDocumentChange(e, "documentName")
              // }
              >
                Document Name
                {/* {props.order === "desc" &&
                    props.sortField === "documentName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )} */}
              </th>
              <th>Delete</th>
            </tr>
          </thead>
          {documentData != null ? (
            <tbody>
              {documentData.map((ln, index) => (
                ln.isDeleted != true && (
                  <tr key={index}>

                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          editDocument(e, ln.documentName, index)
                        }
                      >
                        {ln.documentName}
                      </Button>
                    </td>
                    <td>{ln.documentName}</td>
                    <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          deleteDocuments(e, ln.documentCode, ln)
                        }
                        disabled={disabledImages}


                      >
                        {<DeleteIcon />}
                      </Button>
                    </td>

                  </tr>
                )
              ))}
            </tbody>
          ) : null}
        </Table>
      </div>
      {/* <div className="mt-3">
        <CustomTable
          data={documentData}
          columns={documentColumns()}
          label={"Inquiry Data List"}
        />
      </div> */}
    </div>

  );
}

function LogisticOrderModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App"></div>
      <LogisticOrder {...props} name="" />
      <br />
    </div>
  );
}

export default LogisticOrderModule;
